$(document).ready(function () {
    setNavigation();
    $(".title-with-children.highlighted").next('ul').addClass('active-item')
  	addBreadcrumps();
});

function setNavigation() {
    var path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);

    $(".majorul li a span").each(function () {
        var href = $(this).closest("a").attr('href');
        if (path.substring(0, href.length) === href) {
          
            var self = $(this);
            
            self.addClass('highlighted');
          	self.addClass('breadcrumb-item');
          	var climbul = $(".highlighted").parents('ul').addClass('active-item');
            var climb = $(".active-item").parents('li').addClass('tree-li');
        }
    });
}
  
  function addBreadcrumps() {
    $(".tree-li").each(function(){
    	$(this).children("a").addClass("breadcrumb-item")
    })
    
    $(".breadcrumb-item").each(function(){
      var self = $(this).clone();
	  console.log(self[0])
      $(".dynamicbreadcrumbs").append(self);
    });
    
   
    
    $(".dynamicbreadcrumbs a").wrap('<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"></li>');
    $(".highlighted.breadcrumb-item").wrap('<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"></li>');
    $(".dynamicbreadcrumbs a").attr('itemprop','item');
    $(".dynamicbreadcrumbs span").attr('itemprop','name');
    
    $(".breadcrumb-item").each(function(){
      var innerbc = $(this).text();
	console.log(innerbc)
    });
    
    $(".dynamicbreadcrumbs span").each(function(){
    	$(this).after('<meta itemprop="position">');
    });
    
    $('meta[itemprop="position"]').each(function(i){
    
      $(this).attr('content', '' + ++i + '')
      
    })     	
  }

/* Cookie consent */
! function(e) {
    if (!e.hasInitialised) {
        var t = {
            escapeRegExp: function(e) {
                return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
            },
            hasClass: function(e, t) {
                var i = " ";
                return 1 === e.nodeType && (i + e.className + i).replace(/[\n\t]/g, i).indexOf(i + t + i) >= 0
            },
            addClass: function(e, t) {
                e.className += " " + t
            },
            removeClass: function(e, t) {
                var i = new RegExp("\\b" + this.escapeRegExp(t) + "\\b");
                e.className = e.className.replace(i, "")
            },
            interpolateString: function(e, t) {
                var i = /{{([a-z][a-z0-9\-_]*)}}/gi;
                return e.replace(i, function(e) {
                    return t(arguments[1]) || ""
                })
            },
            getCookie: function(e) {
                var t = "; " + document.cookie,
                    i = t.split("; " + e + "=");
                return 2 != i.length ? void 0 : i.pop().split(";").shift()
            },
            setCookie: function(e, t, i, n, o) {
                var s = new Date;
                s.setDate(s.getDate() + (i || 365));
                var r = [e + "=" + t, "expires=" + s.toUTCString(), "path=" + (o || "/")];
                n && r.push("domain=" + n), document.cookie = r.join(";")
            },
            deepExtend: function(e, t) {
                for (var i in t) t.hasOwnProperty(i) && (i in e && this.isPlainObject(e[i]) && this.isPlainObject(t[i]) ? this.deepExtend(e[i], t[i]) : e[i] = t[i]);
                return e
            },
            throttle: function(e, t) {
                var i = !1;
                return function() {
                    i || (e.apply(this, arguments), i = !0, setTimeout(function() {
                        i = !1
                    }, t))
                }
            },
            hash: function(e) {
                var t, i, n, o = 0;
                if (0 === e.length) return o;
                for (t = 0, n = e.length; t < n; ++t) i = e.charCodeAt(t), o = (o << 5) - o + i, o |= 0;
                return o
            },
            normaliseHex: function(e) {
                return "#" == e[0] && (e = e.substr(1)), 3 == e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), e
            },
            getContrast: function(e) {
                e = this.normaliseHex(e);
                var t = parseInt(e.substr(0, 2), 16),
                    i = parseInt(e.substr(2, 2), 16),
                    n = parseInt(e.substr(4, 2), 16),
                    o = (299 * t + 587 * i + 114 * n) / 1e3;
                return o >= 128 ? "#000" : "#fff"
            },
            getLuminance: function(e) {
                var t = parseInt(this.normaliseHex(e), 16),
                    i = 38,
                    n = (t >> 16) + i,
                    o = (t >> 8 & 255) + i,
                    s = (255 & t) + i,
                    r = (16777216 + 65536 * (n < 255 ? n < 1 ? 0 : n : 255) + 256 * (o < 255 ? o < 1 ? 0 : o : 255) + (s < 255 ? s < 1 ? 0 : s : 255)).toString(16).slice(1);
                return "#" + r
            },
            isMobile: function() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            },
            isPlainObject: function(e) {
                return "object" == typeof e && null !== e && e.constructor == Object
            }
        };
        e.status = {
            deny: "deny",
            allow: "allow",
            dismiss: "dismiss"
        }, e.transitionEnd = function() {
            var e = document.createElement("div"),
                t = {
                    t: "transitionend",
                    OT: "oTransitionEnd",
                    msT: "MSTransitionEnd",
                    MozT: "transitionend",
                    WebkitT: "webkitTransitionEnd"
                };
            for (var i in t)
                if (t.hasOwnProperty(i) && "undefined" != typeof e.style[i + "ransition"]) return t[i];
            return ""
        }(), e.hasTransition = !!e.transitionEnd;
        var i = Object.keys(e.status).map(t.escapeRegExp);
        e.customStyles = {}, e.Popup = function() {
            function n() {
                this.initialise.apply(this, arguments)
            }

            function o(e) {
                this.openingTimeout = null, t.removeClass(e, "cc-invisible")
            }

            function s(t) {
                t.style.display = "none", t.removeEventListener(e.transitionEnd, this.afterTransition), this.afterTransition = null
            }

            function r() {
                var t = this.options.onInitialise.bind(this);
                if (!window.navigator.cookieEnabled) return t(e.status.deny), !0;
                if (window.CookiesOK || window.navigator.CookiesOK) return t(e.status.allow), !0;
                var i = Object.keys(e.status),
                    n = this.getStatus(),
                    o = i.indexOf(n) >= 0;
                return o && t(n), o
            }

            function a() {
                var e = this.options.position.split("-"),
                    t = [];
                return e.forEach(function(e) {
                    t.push("cc-" + e)
                }), t
            }

            function c() {
                var e = this.options,
                    i = "top" == e.position || "bottom" == e.position ? "banner" : "floating";
                t.isMobile() && (i = "floating");
                var n = ["cc-" + i, "cc-type-" + e.type, "cc-theme-" + e.theme];
                e["static"] && n.push("cc-static"), n.push.apply(n, a.call(this));
                p.call(this, this.options.palette);
                return this.customStyleSelector && n.push(this.customStyleSelector), n
            }

            function l() {
                var e = {},
                    i = this.options;
                i.showLink || (i.elements.link = "", i.elements.messagelink = i.elements.message), Object.keys(i.elements).forEach(function(n) {
                    e[n] = t.interpolateString(i.elements[n], function(e) {
                        var t = i.content[e];
                        return e && "string" == typeof t && t.length ? t : ""
                    })
                });
                var n = i.compliance[i.type];
                n || (n = i.compliance.info), e.compliance = t.interpolateString(n, function(t) {
                    return e[t]
                });
                var o = i.layouts[i.layout];
                return o || (o = i.layouts.basic), t.interpolateString(o, function(t) {
                    return e[t]
                })
            }

            function u(i) {
                var n = this.options,
                    o = document.createElement("div"),
                    s = n.container && 1 === n.container.nodeType ? n.container : document.body;
                o.innerHTML = i;
                var r = o.children[0];
                return r.style.display = "none", t.hasClass(r, "cc-window") && e.hasTransition && t.addClass(r, "cc-invisible"), this.onButtonClick = h.bind(this), r.addEventListener("click", this.onButtonClick), n.autoAttach && (s.firstChild ? s.insertBefore(r, s.firstChild) : s.appendChild(r)), r
            }

            function h(n) {
                var o = n.target;
                if (t.hasClass(o, "cc-btn")) {
                    var s = o.className.match(new RegExp("\\bcc-(" + i.join("|") + ")\\b")),
                        r = s && s[1] || !1;
                    r && (this.setStatus(r), this.close(!0))
                }
                t.hasClass(o, "cc-close") && (this.setStatus(e.status.dismiss), this.close(!0)), t.hasClass(o, "cc-revoke") && this.revokeChoice()
            }

            function p(e) {
                var i = t.hash(JSON.stringify(e)),
                    n = "cc-color-override-" + i,
                    o = t.isPlainObject(e);
                return this.customStyleSelector = o ? n : null, o && d(i, e, "." + n), o
            }

            function d(i, n, o) {
                if (e.customStyles[i]) return void++e.customStyles[i].references;
                var s = {},
                    r = n.popup,
                    a = n.button,
                    c = n.highlight;
                r && (r.text = r.text ? r.text : t.getContrast(r.background), r.link = r.link ? r.link : r.text, s[o + ".cc-window"] = ["color: " + r.text, "background-color: " + r.background], s[o + ".cc-revoke"] = ["color: " + r.text, "background-color: " + r.background], s[o + " .cc-link," + o + " .cc-link:active," + o + " .cc-link:visited"] = ["color: " + r.link], a && (a.text = a.text ? a.text : t.getContrast(a.background), a.border = a.border ? a.border : "transparent", s[o + " .cc-btn"] = ["color: " + a.text, "border-color: " + a.border, "background-color: " + a.background], "transparent" != a.background && (s[o + " .cc-btn:hover, " + o + " .cc-btn:focus"] = ["background-color: " + v(a.background)]), c ? (c.text = c.text ? c.text : t.getContrast(c.background), c.border = c.border ? c.border : "transparent", s[o + " .cc-highlight .cc-btn:first-child"] = ["color: " + c.text, "border-color: " + c.border, "background-color: " + c.background]) : s[o + " .cc-highlight .cc-btn:first-child"] = ["color: " + r.text]));
                var l = document.createElement("style");
                document.head.appendChild(l), e.customStyles[i] = {
                    references: 1,
                    element: l.sheet
                };
                var u = -1;
                for (var h in s) s.hasOwnProperty(h) && l.sheet.insertRule(h + "{" + s[h].join(";") + "}", ++u)
            }

            function v(e) {
                return e = t.normaliseHex(e), "000000" == e ? "#222" : t.getLuminance(e)
            }

            function f(i) {
                if (t.isPlainObject(i)) {
                    var n = t.hash(JSON.stringify(i)),
                        o = e.customStyles[n];
                    if (o && !--o.references) {
                        var s = o.element.ownerNode;
                        s && s.parentNode && s.parentNode.removeChild(s), e.customStyles[n] = null
                    }
                }
            }

            function m(e, t) {
                for (var i = 0, n = e.length; i < n; ++i) {
                    var o = e[i];
                    if (o instanceof RegExp && o.test(t) || "string" == typeof o && o.length && o === t) return !0
                }
                return !1
            }

            function b() {
                var t = this.setStatus.bind(this),
                    i = this.options.dismissOnTimeout;
                "number" == typeof i && i >= 0 && (this.dismissTimeout = window.setTimeout(function() {
                    t(e.status.dismiss)
                }, Math.floor(i)));
                var n = this.options.dismissOnScroll;
                if ("number" == typeof n && n >= 0) {
                    var o = function(i) {
                        window.pageYOffset > Math.floor(n) && (t(e.status.dismiss), window.removeEventListener("scroll", o), this.onWindowScroll = null)
                    };
                    this.onWindowScroll = o, window.addEventListener("scroll", o)
                }
            }

            function y() {
                if ("info" != this.options.type && (this.options.revokable = !0), t.isMobile() && (this.options.animateRevokable = !1), this.options.revokable) {
                    var e = a.call(this);
                    this.options.animateRevokable && e.push("cc-animate"), this.customStyleSelector && e.push(this.customStyleSelector);
                    var i = this.options.revokeBtn.replace("{{classes}}", e.join(" "));
                    this.revokeBtn = u.call(this, i);
                    var n = this.revokeBtn;
                    if (this.options.animateRevokable) {
                        var o = t.throttle(function(e) {
                            var i = !1,
                                o = 20,
                                s = window.innerHeight - 20;
                            t.hasClass(n, "cc-top") && e.clientY < o && (i = !0), t.hasClass(n, "cc-bottom") && e.clientY > s && (i = !0), i ? t.hasClass(n, "cc-active") || t.addClass(n, "cc-active") : t.hasClass(n, "cc-active") && t.removeClass(n, "cc-active")
                        }, 200);
                        this.onMouseMove = o, window.addEventListener("mousemove", o)
                    }
                }
            }
            var g = {
                enabled: !0,
                container: null,
                cookie: {
                    name: "cookieconsent_status",
                    path: "/",
                    domain: "",
                    expiryDays: 365
                },
                onPopupOpen: function() {},
                onPopupClose: function() {},
                onInitialise: function(e) {},
                onStatusChange: function(e, t) {},
                onRevokeChoice: function() {},
                content: {
                    header: "Cookies used on the website!",
                    message: "This website uses cookies to ensure you get the best experience on our website.",
                    dismiss: "Got it!",
                    allow: "Allow cookies",
                    deny: "Decline",
                    link: "Learn more",
                    href: "http://cookiesandyou.com",
                    close: "&#x274c;"
                },
                elements: {
                    header: '<span class="cc-header">{{header}}</span>&nbsp;',
                    message: '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
                    messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span>',
                    dismiss: '<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',
                    allow: '<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',
                    deny: '<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
                    link: '<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',
                    close: '<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'
                },
                window: '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',
                revokeBtn: '<div class="cc-revoke {{classes}}">Cookie Policy</div>',
                compliance: {
                    info: '<div class="cc-compliance">{{dismiss}}</div>',
                    "opt-in": '<div class="cc-compliance cc-highlight">{{dismiss}}{{allow}}</div>',
                    "opt-out": '<div class="cc-compliance cc-highlight">{{deny}}{{dismiss}}</div>'
                },
                type: "info",
                layouts: {
                    basic: "{{messagelink}}{{compliance}}",
                    "basic-close": "{{messagelink}}{{compliance}}{{close}}",
                    "basic-header": "{{header}}{{message}}{{link}}{{compliance}}"
                },
                layout: "basic",
                position: "bottom",
                theme: "block",
                "static": !1,
                palette: null,
                revokable: !1,
                animateRevokable: !0,
                showLink: !0,
                dismissOnScroll: !1,
                dismissOnTimeout: !1,
                autoOpen: !0,
                autoAttach: !0,
                whitelistPage: [],
                blacklistPage: [],
                overrideHTML: null
            };
            return n.prototype.initialise = function(e) {
                this.options && this.destroy(), t.deepExtend(this.options = {}, g), t.isPlainObject(e) && t.deepExtend(this.options, e), r.call(this) && (this.options.enabled = !1), m(this.options.blacklistPage, location.pathname) && (this.options.enabled = !1), m(this.options.whitelistPage, location.pathname) && (this.options.enabled = !0);
                var i = this.options.window.replace("{{classes}}", c.call(this).join(" ")).replace("{{children}}", l.call(this)),
                    n = this.options.overrideHTML;
                if ("string" == typeof n && n.length && (i = n), this.options["static"]) {
                    var o = u.call(this, '<div class="cc-grower">' + i + "</div>");
                    o.style.display = "", this.element = o.firstChild, this.element.style.display = "none", t.addClass(this.element, "cc-invisible")
                } else this.element = u.call(this, i);
                b.call(this), y.call(this), this.options.autoOpen && this.autoOpen()
            }, n.prototype.destroy = function() {
                this.onButtonClick && this.element && (this.element.removeEventListener("click", this.onButtonClick), this.onButtonClick = null), this.dismissTimeout && (clearTimeout(this.dismissTimeout), this.dismissTimeout = null), this.onWindowScroll && (window.removeEventListener("scroll", this.onWindowScroll), this.onWindowScroll = null), this.onMouseMove && (window.removeEventListener("mousemove", this.onMouseMove), this.onMouseMove = null), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.revokeBtn && this.revokeBtn.parentNode && this.revokeBtn.parentNode.removeChild(this.revokeBtn), this.revokeBtn = null, f(this.options.palette), this.options = null
            }, n.prototype.open = function(t) {
                if (this.element) return this.isOpen() || (e.hasTransition ? this.fadeIn() : this.element.style.display = "", this.options.revokable && this.toggleRevokeButton(), this.options.onPopupOpen.call(this)), this
            }, n.prototype.close = function(t) {
                if (this.element) return this.isOpen() && (e.hasTransition ? this.fadeOut() : this.element.style.display = "none", t && this.options.revokable && this.toggleRevokeButton(!0), this.options.onPopupClose.call(this)), this
            }, n.prototype.fadeIn = function() {
                var i = this.element;
                if (e.hasTransition && i && (this.afterTransition && s.call(this, i), t.hasClass(i, "cc-invisible"))) {
                    if (i.style.display = "", this.options["static"]) {
                        var n = this.element.clientHeight;
                        this.element.parentNode.style.maxHeight = n + "px"
                    }
                    var r = 20;
                    this.openingTimeout = setTimeout(o.bind(this, i), r)
                }
            }, n.prototype.fadeOut = function() {
                var i = this.element;
                e.hasTransition && i && (this.openingTimeout && (clearTimeout(this.openingTimeout), o.bind(this, i)), t.hasClass(i, "cc-invisible") || (this.options["static"] && (this.element.parentNode.style.maxHeight = ""), this.afterTransition = s.bind(this, i), i.addEventListener(e.transitionEnd, this.afterTransition), t.addClass(i, "cc-invisible")))
            }, n.prototype.isOpen = function() {
                return this.element && "" == this.element.style.display && (!e.hasTransition || !t.hasClass(this.element, "cc-invisible"))
            }, n.prototype.toggleRevokeButton = function(e) {
                this.revokeBtn && (this.revokeBtn.style.display = e ? "" : "none")
            }, n.prototype.revokeChoice = function(e) {
                this.options.enabled = !0, this.clearStatus(), this.options.onRevokeChoice.call(this), e || this.autoOpen()
            }, n.prototype.hasAnswered = function(t) {
                return Object.keys(e.status).indexOf(this.getStatus()) >= 0
            }, n.prototype.hasConsented = function(t) {
                var i = this.getStatus();
                return i == e.status.allow || i == e.status.dismiss
            }, n.prototype.autoOpen = function(e) {
                !this.hasAnswered() && this.options.enabled && this.open()
            }, n.prototype.setStatus = function(i) {
                var n = this.options.cookie,
                    o = t.getCookie(n.name),
                    s = Object.keys(e.status).indexOf(o) >= 0;
                Object.keys(e.status).indexOf(i) >= 0 ? (t.setCookie(n.name, i, n.expiryDays, n.domain, n.path), this.options.onStatusChange.call(this, i, s)) : this.clearStatus()
            }, n.prototype.getStatus = function() {
                return t.getCookie(this.options.cookie.name)
            }, n.prototype.clearStatus = function() {
                var e = this.options.cookie;
                t.setCookie(e.name, "", -1, e.domain, e.path)
            }, n
        }(), e.Location = function() {
            function e(e) {
                t.deepExtend(this.options = {}, s), t.isPlainObject(e) && t.deepExtend(this.options, e), this.currentServiceIndex = -1
            }

            function i(e, t, i) {
                var n, o = document.createElement("script");
                o.type = "text/" + (e.type || "javascript"), o.src = e.src || e, o.async = !1, o.onreadystatechange = o.onload = function() {
                    var e = o.readyState;
                    clearTimeout(n), t.done || e && !/loaded|complete/.test(e) || (t.done = !0, t(), o.onreadystatechange = o.onload = null)
                }, document.body.appendChild(o), n = setTimeout(function() {
                    t.done = !0, t(), o.onreadystatechange = o.onload = null
                }, i)
            }

            function n(e, t, i, n, o) {
                var s = new(window.XMLHttpRequest || window.ActiveXObject)("MSXML2.XMLHTTP.3.0");
                if (s.open(n ? "POST" : "GET", e, 1), s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), s.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), Array.isArray(o))
                    for (var r = 0, a = o.length; r < a; ++r) {
                        var c = o[r].split(":", 2);
                        s.setRequestHeader(c[0].replace(/^\s+|\s+$/g, ""), c[1].replace(/^\s+|\s+$/g, ""))
                    }
                "function" == typeof t && (s.onreadystatechange = function() {
                    s.readyState > 3 && t(s)
                }), s.send(n)
            }

            function o(e) {
                return new Error("Error [" + (e.code || "UNKNOWN") + "]: " + e.error)
            }
            var s = {
                timeout: 5e3,
                services: ["freegeoip", "ipinfo", "maxmind"],
                serviceDefinitions: {
                    freegeoip: function() {
                        return {
                            url: "//freegeoip.net/json/?callback={callback}",
                            isScript: !0,
                            callback: function(e, t) {
                                try {
                                    var i = JSON.parse(t);
                                    return i.error ? o(i) : {
                                        code: i.country_code
                                    }
                                } catch (n) {
                                    return o({
                                        error: "Invalid response (" + n + ")"
                                    })
                                }
                            }
                        }
                    },
                    ipinfo: function() {
                        return {
                            url: "//ipinfo.io",
                            headers: ["Accept: application/json"],
                            callback: function(e, t) {
                                try {
                                    var i = JSON.parse(t);
                                    return i.error ? o(i) : {
                                        code: i.country
                                    }
                                } catch (n) {
                                    return o({
                                        error: "Invalid response (" + n + ")"
                                    })
                                }
                            }
                        }
                    },
                    ipinfodb: function(e) {
                        return {
                            url: "//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",
                            isScript: !0,
                            callback: function(e, t) {
                                try {
                                    var i = JSON.parse(t);
                                    return "ERROR" == i.statusCode ? o({
                                        error: i.statusMessage
                                    }) : {
                                        code: i.countryCode
                                    }
                                } catch (n) {
                                    return o({
                                        error: "Invalid response (" + n + ")"
                                    })
                                }
                            }
                        }
                    },
                    maxmind: function() {
                        return {
                            url: "//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",
                            isScript: !0,
                            callback: function(e) {
                                return window.geoip2 ? void geoip2.country(function(t) {
                                    try {
                                        e({
                                            code: t.country.iso_code
                                        })
                                    } catch (i) {
                                        e(o(i))
                                    }
                                }, function(t) {
                                    e(o(t))
                                }) : void e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))
                            }
                        }
                    }
                }
            };
            return e.prototype.getNextService = function() {
                var e;
                do e = this.getServiceByIdx(++this.currentServiceIndex); while (this.currentServiceIndex < this.options.services.length && !e);
                return e
            }, e.prototype.getServiceByIdx = function(e) {
                var i = this.options.services[e];
                if ("function" == typeof i) {
                    var n = i();
                    return n.name && t.deepExtend(n, this.options.serviceDefinitions[n.name](n)), n
                }
                return "string" == typeof i ? this.options.serviceDefinitions[i]() : t.isPlainObject(i) ? this.options.serviceDefinitions[i.name](i) : null
            }, e.prototype.locate = function(e, t) {
                var i = this.getNextService();
                return i ? (this.callbackComplete = e, this.callbackError = t, void this.runService(i, this.runNextServiceOnError.bind(this))) : void t(new Error("No services to run"))
            }, e.prototype.setupUrl = function(e) {
                var t = this.getCurrentServiceOpts();
                return e.url.replace(/\{(.*?)\}/g, function(i, n) {
                    if ("callback" === n) {
                        var o = "callback" + Date.now();
                        return window[o] = function(t) {
                            e.__JSONP_DATA = JSON.stringify(t)
                        }, o
                    }
                    if (n in t.interpolateUrl) return t.interpolateUrl[n]
                })
            }, e.prototype.runService = function(e, t) {
                var o = this;
                if (e && e.url && e.callback) {
                    var s = e.isScript ? i : n,
                        r = this.setupUrl(e);
                    s(r, function(i) {
                        var n = i ? i.responseText : "";
                        e.__JSONP_DATA && (n = e.__JSONP_DATA, delete e.__JSONP_DATA), o.runServiceCallback.call(o, t, e, n)
                    }, this.options.timeout, e.data, e.headers)
                }
            }, e.prototype.runServiceCallback = function(e, t, i) {
                var n = this,
                    o = function(t) {
                        s || n.onServiceResult.call(n, e, t)
                    },
                    s = t.callback(o, i);
                s && this.onServiceResult.call(this, e, s)
            }, e.prototype.onServiceResult = function(e, t) {
                t instanceof Error || t && t.error ? e.call(this, t, null) : e.call(this, null, t)
            }, e.prototype.runNextServiceOnError = function(e, t) {
                if (e) {
                    this.logError(e);
                    var i = this.getNextService();
                    i ? this.runService(i, this.runNextServiceOnError.bind(this)) : this.completeService.call(this, this.callbackError, new Error("All services failed"))
                } else this.completeService.call(this, this.callbackComplete, t)
            }, e.prototype.getCurrentServiceOpts = function() {
                var e = this.options.services[this.currentServiceIndex];
                return "string" == typeof e ? {
                    name: e
                } : "function" == typeof e ? e() : t.isPlainObject(e) ? e : {}
            }, e.prototype.completeService = function(e, t) {
                this.currentServiceIndex = -1, e && e(t)
            }, e.prototype.logError = function(e) {
                var t = this.currentServiceIndex,
                    i = this.getServiceByIdx(t);
                console.error("The service[" + t + "] (" + i.url + ") responded with the following error", e)
            }, e
        }(), e.Law = function() {
            function e(e) {
                this.initialise.apply(this, arguments)
            }
            var i = {
                regionalLaw: !0,
                hasLaw: ["AT", "BE", "BG", "HR", "CZ", "CY", "DK", "EE", "FI", "FR", "DE", "EL", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "SK", "SI", "ES", "SE", "GB", "UK"],
                revokable: ["HR", "CY", "DK", "EE", "FR", "DE", "LV", "LT", "NL", "PT", "ES"],
                explicitAction: ["HR", "IT", "ES"]
            };
            return e.prototype.initialise = function(e) {
                t.deepExtend(this.options = {}, i), t.isPlainObject(e) && t.deepExtend(this.options, e)
            }, e.prototype.get = function(e) {
                var t = this.options;
                return {
                    hasLaw: t.hasLaw.indexOf(e) >= 0,
                    revokable: t.revokable.indexOf(e) >= 0,
                    explicitAction: t.explicitAction.indexOf(e) >= 0
                }
            }, e.prototype.applyLaw = function(e, t) {
                var i = this.get(t);
                return i.hasLaw || (e.enabled = !1), this.options.regionalLaw && (i.revokable && (e.revokable = !0), i.explicitAction && (e.dismissOnScroll = !1, e.dismissOnTimeout = !1)), e
            }, e
        }(), e.initialise = function(t, i, n) {
            var o = new e.Law(t.law);
            i || (i = function() {}), n || (n = function() {}), e.getCountryCode(t, function(n) {
                delete t.law, delete t.location, n.code && (t = o.applyLaw(t, n.code)), i(new e.Popup(t))
            }, function(i) {
                delete t.law, delete t.location, n(i, new e.Popup(t))
            })
        }, e.getCountryCode = function(t, i, n) {
            if (t.law && t.law.countryCode) return void i({
                code: t.law.countryCode
            });
            if (t.location) {
                var o = new e.Location(t.location);
                return void o.locate(function(e) {
                    i(e || {})
                }, n)
            }
            i({})
        }, e.utils = t, e.hasInitialised = !0, window.cookieconsent = e
    }
}(window.cookieconsent || {});
! function(t) {
    var e, i, s, o, n, r, a, l, d, c, p, h, u, f, g, v, m, y, w, b, S, k, C, _, T, $, z, x, A, E, P, M, L, O, D, j;
    t = jQuery = t;
    e = window, i = function(t, e) {
            "use strict";
            if (e.getElementsByClassName) {
                var i, s, o = e.documentElement,
                    n = t.Date,
                    r = t.HTMLPictureElement,
                    a = "addEventListener",
                    l = "getAttribute",
                    d = t[a],
                    c = t.setTimeout,
                    p = t.requestAnimationFrame || c,
                    h = t.requestIdleCallback,
                    u = /^picture$/i,
                    f = ["load", "error", "lazyincluded", "_lazyloaded"],
                    g = {},
                    v = Array.prototype.forEach,
                    m = function(t, e) {
                        return g[e] || (g[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), g[e].test(t[l]("class") || "") && g[e]
                    },
                    y = function(t, e) {
                        m(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
                    },
                    w = function(t, e) {
                        var i;
                        (i = m(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(i, " "))
                    },
                    b = function(t, e, i) {
                        var s = i ? a : "removeEventListener";
                        i && b(t, e), f.forEach(function(i) {
                            t[s](i, e)
                        })
                    },
                    S = function(t, s, o, n, r) {
                        var a = e.createEvent("CustomEvent");
                        return o || (o = {}), o.instance = i, a.initCustomEvent(s, !n, !r, o), t.dispatchEvent(a), a
                    },
                    k = function(e, i) {
                        var o;
                        !r && (o = t.picturefill || s.pf) ? o({
                            reevaluate: !0,
                            elements: [e]
                        }) : i && i.src && (e.src = i.src)
                    },
                    C = function(t, e) {
                        return (getComputedStyle(t, null) || {})[e]
                    },
                    _ = function(t, e, i) {
                        for (i = i || t.offsetWidth; i < s.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
                        return i
                    },
                    T = (St = [], kt = bt = [], (_t = function(t, i) {
                        yt && !i ? t.apply(this, arguments) : (kt.push(t), wt || (wt = !0, (e.hidden ? c : p)(Ct)))
                    })._lsFlush = Ct = function() {
                        var t = kt;
                        for (kt = bt.length ? St : bt, yt = !0, wt = !1; t.length;) t.shift()();
                        yt = !1
                    }, _t),
                    $ = function(t, e) {
                        return e ? function() {
                            T(t)
                        } : function() {
                            var e = this,
                                i = arguments;
                            T(function() {
                                t.apply(e, i)
                            })
                        }
                    },
                    z = function(t) {
                        var e, i, s = function() {
                                e = null, t()
                            },
                            o = function() {
                                var t = n.now() - i;
                                99 > t ? c(o, 99 - t) : (h || s)(s)
                            };
                        return function() {
                            i = n.now(), e || (e = c(o, 99))
                        }
                    };
                ! function() {
                    var e, i = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: .8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 300
                    };
                    s = t.lazySizesConfig || t.lazysizesConfig || {};
                    for (e in i) e in s || (s[e] = i[e]);
                    t.lazySizesConfig = s, c(function() {
                        s.init && E()
                    })
                }();
                var x = (et = /^img$/i, it = /^iframe$/i, st = "onscroll" in t && !/glebot/.test(navigator.userAgent), ot = 0, nt = 0, rt = -1, at = function(t) {
                        nt--, t && t.target && b(t.target, at), (!t || 0 > nt || !t.target) && (nt = 0)
                    }, lt = function(t, i) {
                        var s, n = t,
                            r = "hidden" == C(e.body, "visibility") || "hidden" != C(t, "visibility");
                        for (X -= i, B += i, F -= i, q += i; r && (n = n.offsetParent) && n != e.body && n != o;) r = (C(n, "opacity") || 1) > 0, r && "visible" != C(n, "overflow") && (s = n.getBoundingClientRect(), r = q > s.left && F < s.right && B > s.top - 1 && X < s.bottom + 1);
                        return r
                    }, Q = dt = function() {
                        var t, n, r, a, d, c, p, h, u, f = i.elements;
                        if ((H = s.loadMode) && 8 > nt && (t = f.length)) {
                            n = 0, rt++, null == Y && ("expand" in s || (s.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), U = s.expand, Y = U * s.expFactor), Y > ot && 1 > nt && rt > 2 && H > 2 && !e.hidden ? (ot = Y, rt = 0) : ot = H > 1 && rt > 1 && 6 > nt ? U : 0;
                            for (; t > n; n++)
                                if (f[n] && !f[n]._lazyRace)
                                    if (st)
                                        if ((h = f[n][l]("data-expand")) && (c = 1 * h) || (c = ot), u !== c && (W = innerWidth + c * V, R = innerHeight + c, p = -1 * c, u = c), r = f[n].getBoundingClientRect(), (B = r.bottom) >= p && (X = r.top) <= R && (q = r.right) >= p * V && (F = r.left) <= W && (B || q || F || X) && (s.loadHidden || "hidden" != C(f[n], "visibility")) && (j && 3 > nt && !h && (3 > H || 4 > rt) || lt(f[n], c))) {
                                            if (vt(f[n]), d = !0, nt > 9) break
                                        } else !d && j && !a && 4 > nt && 4 > rt && H > 2 && (D[0] || s.preloadAfterLoad) && (D[0] || !h && (B || q || F || X || "auto" != f[n][l](s.sizesAttr))) && (a = D[0] || f[n]);
                            else vt(f[n]);
                            a && !d && vt(a)
                        }
                    }, G = 0, J = s.ricTimeout, K = function() {
                        Z = !1, G = n.now(), Q()
                    }, tt = h && s.ricTimeout ? function() {
                        h(K, {
                            timeout: J
                        }), J !== s.ricTimeout && (J = s.ricTimeout)
                    } : $(function() {
                        c(K)
                    }, !0), ct = function(t) {
                        var e;
                        (t = !0 === t) && (J = 33), Z || (Z = !0, 0 > (e = 125 - (n.now() - G)) && (e = 0), t || 9 > e && h ? tt() : c(tt, e))
                    }, ht = $(pt = function(t) {
                        y(t.target, s.loadedClass), w(t.target, s.loadingClass), b(t.target, ut), S(t.target, "lazyloaded")
                    }), ut = function(t) {
                        ht({
                            target: t.target
                        })
                    }, ft = function(t) {
                        var e, i = t[l](s.srcsetAttr);
                        (e = s.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
                    }, gt = $(function(t, e, i, o, n) {
                        var r, a, d, p, h, f;
                        (h = S(t, "lazybeforeunveil", e)).defaultPrevented || (o && (i ? y(t, s.autosizesClass) : t.setAttribute("sizes", o)), a = t[l](s.srcsetAttr), r = t[l](s.srcAttr), n && (d = t.parentNode, p = d && u.test(d.nodeName || "")), f = e.firesLoad || "src" in t && (a || r || p), h = {
                            target: t
                        }, f && (b(t, at, !0), clearTimeout(N), N = c(at, 2500), y(t, s.loadingClass), b(t, ut, !0)), p && v.call(d.getElementsByTagName("source"), ft), a ? t.setAttribute("srcset", a) : r && !p && (it.test(t.nodeName) ? function(t, e) {
                            try {
                                t.contentWindow.location.replace(e)
                            } catch (i) {
                                t.src = e
                            }
                        }(t, r) : t.src = r), n && (a || p) && k(t, {
                            src: r
                        })), t._lazyRace && delete t._lazyRace, w(t, s.lazyClass), T(function() {
                            (!f || t.complete && t.naturalWidth > 1) && (f ? at(h) : nt--, pt(h))
                        }, !0)
                    }), mt = function() {
                        if (!j) {
                            if (n.now() - I < 999) return void c(mt, 999);
                            var t = z(function() {
                                s.loadMode = 3, ct()
                            });
                            j = !0, s.loadMode = 3, ct(), d("scroll", function() {
                                3 == s.loadMode && (s.loadMode = 2), t()
                            }, !0)
                        }
                    }, {
                        _: function() {
                            I = n.now(), i.elements = e.getElementsByClassName(s.lazyClass), D = e.getElementsByClassName(s.lazyClass + " " + s.preloadClass), V = s.hFac, d("scroll", ct, !0), d("resize", ct, !0), t.MutationObserver ? new MutationObserver(ct).observe(o, {
                                childList: !0,
                                subtree: !0,
                                attributes: !0
                            }) : (o[a]("DOMNodeInserted", ct, !0), o[a]("DOMAttrModified", ct, !0), setInterval(ct, 999)), d("hashchange", ct, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) {
                                e[a](t, ct, !0)
                            }), /d$|^c/.test(e.readyState) ? mt() : (d("load", mt), e[a]("DOMContentLoaded", ct), c(mt, 2e4)), i.elements.length ? (dt(), T._lsFlush()) : ct()
                        },
                        checkElems: ct,
                        unveil: vt = function(t) {
                            var e, i = et.test(t.nodeName),
                                o = i && (t[l](s.sizesAttr) || t[l]("sizes")),
                                n = "auto" == o;
                            (!n && j || !i || !t[l]("src") && !t.srcset || t.complete || m(t, s.errorClass) || !m(t, s.lazyClass)) && (e = S(t, "lazyunveilread").detail, n && A.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, nt++, gt(t, e, n, o, i))
                        }
                    }),
                    A = (M = $(function(t, e, i, s) {
                        var o, n, r;
                        if (t._lazysizesWidth = s, s += "px", t.setAttribute("sizes", s), u.test(e.nodeName || ""))
                            for (o = e.getElementsByTagName("source"), n = 0, r = o.length; r > n; n++) o[n].setAttribute("sizes", s);
                        i.detail.dataAttr || k(t, i.detail)
                    }), L = function(t, e, i) {
                        var s, o = t.parentNode;
                        o && (i = _(t, o, i), (s = S(t, "lazybeforesizes", {
                            width: i,
                            dataAttr: !!e
                        })).defaultPrevented || (i = s.detail.width) && i !== t._lazysizesWidth && M(t, o, s, i))
                    }, {
                        _: function() {
                            P = e.getElementsByClassName(s.autosizesClass), d("resize", O)
                        },
                        checkElems: O = z(function() {
                            var t, e = P.length;
                            if (e)
                                for (t = 0; e > t; t++) L(P[t])
                        }),
                        updateElem: L
                    }),
                    E = function() {
                        E.i || (E.i = !0, A._(), x._())
                    };
                return i = {
                    cfg: s,
                    autoSizer: A,
                    loader: x,
                    init: E,
                    uP: k,
                    aC: y,
                    rC: w,
                    hC: m,
                    fire: S,
                    gW: _,
                    rAF: T
                }
            }
            var P, M, L, O;
            var D, j, N, H, I, W, R, X, F, q, B, U, Y, V, Q, Z, G, J, K, tt, et, it, st, ot, nt, rt, at, lt, dt, ct, pt, ht, ut, ft, gt, vt, mt;
            var yt, wt, bt, St, kt, Ct, _t
        }(e, e.document), e.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i), s = window, n = function() {
            o(s.lazySizes), s.removeEventListener("lazyunveilread", n, !0)
        }, o = (o = function(t, e, i) {
            "use strict";

            function s(t, i, s) {
                var o, n, a, d = 0,
                    c = 0,
                    f = s;
                if (t) {
                    if ("container" === i.ratio) {
                        for (d = f.scrollWidth, c = f.scrollHeight; !(d && c || f === e);) f = f.parentNode, d = f.scrollWidth, c = f.scrollHeight;
                        d && c && (i.ratio = c / d)
                    }
                    o = t, n = i, (a = []).srcset = [], n.absUrl && (v.setAttribute("href", o), o = v.href), o = ((n.prefix || "") + o + (n.postfix || "")).replace(u, function(t, e) {
                        return l[typeof n[e]] ? n[e] : t
                    }), n.widths.forEach(function(t) {
                        var e = n.widthmap[t] || t,
                            i = {
                                u: o.replace(p, e).replace(h, n.ratio ? Math.round(t * n.ratio) : ""),
                                w: t
                            };
                        a.push(i), a.srcset.push(i.c = i.u + " " + t + "w")
                    }), (t = a).isPicture = i.isPicture, y && "IMG" == s.nodeName.toUpperCase() ? s.removeAttribute(r.srcsetAttr) : s.setAttribute(r.srcsetAttr, t.srcset.join(", ")), Object.defineProperty(s, "_lazyrias", {
                        value: t,
                        writable: !0
                    })
                }
            }

            function o(e, s) {
                var o = function(e, i) {
                    var s, o, n, r, l = t.getComputedStyle(e);
                    o = e.parentNode, r = {
                        isPicture: !(!o || !c.test(o.nodeName || ""))
                    }, n = function(t, i) {
                        var s = e.getAttribute("data-" + t);
                        if (!s) {
                            var o = l.getPropertyValue("--ls-" + t);
                            o && (s = o.trim())
                        }
                        if (s) {
                            if ("true" == s) s = !0;
                            else if ("false" == s) s = !1;
                            else if (d.test(s)) s = parseFloat(s);
                            else if ("function" == typeof a[t]) s = a[t](e, s);
                            else if (f.test(s)) try {
                                s = JSON.parse(s)
                            } catch (t) {}
                            r[t] = s
                        } else t in a && "function" != typeof a[t] ? r[t] = a[t] : i && "function" == typeof a[t] && (r[t] = a[t](e, s))
                    };
                    for (s in a) n(s);
                    return i.replace(u, function(t, e) {
                        e in r || n(e, !0)
                    }), r
                }(e, s);
                return a.modifyOptions.call(e, {
                    target: e,
                    details: o,
                    detail: o
                }), i.fire(e, "lazyriasmodifyoptions", o), o
            }

            function n(t) {
                return t.getAttribute(t.getAttribute("data-srcattr") || a.srcAttr) || t.getAttribute(r.srcsetAttr) || t.getAttribute(r.srcAttr) || t.getAttribute("data-pfsrcset") || ""
            }
            var r, a, l = {
                    string: 1,
                    number: 1
                },
                d = /^\-*\+*\d+\.*\d*$/,
                c = /^picture$/i,
                p = /\s*\{\s*width\s*\}\s*/i,
                h = /\s*\{\s*height\s*\}\s*/i,
                u = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                f = /^\[.*\]|\{.*\}$/,
                g = /^(?:auto|\d+(px)?)$/,
                v = e.createElement("a"),
                m = e.createElement("img"),
                y = "srcset" in m && !("sizes" in m),
                w = !!t.HTMLPictureElement && !y;
            ! function() {
                var e, s = {
                    prefix: "",
                    postfix: "",
                    srcAttr: "data-src",
                    absUrl: !1,
                    modifyOptions: function() {},
                    widthmap: {},
                    ratio: !1
                };
                (r = i && i.cfg || t.lazySizesConfig) || (r = {}, t.lazySizesConfig = r), r.supportsType || (r.supportsType = function(t) {
                    return !t
                }), r.rias || (r.rias = {}), "widths" in (a = r.rias) || (a.widths = [], function(t) {
                    for (var e, i = 0; !e || 3e3 > e;) i += 5, i > 30 && (i += 1), e = 36 * i, t.push(e)
                }(a.widths));
                for (e in s) e in a || (a[e] = s[e])
            }(), addEventListener("lazybeforesizes", function(t) {
                var e, l, d, c, h, u, f, v, m, y, b, S, k;
                if (t.detail.instance == i && (e = t.target, t.detail.dataAttr && !t.defaultPrevented && !a.disabled && (m = e.getAttribute(r.sizesAttr) || e.getAttribute("sizes")) && g.test(m))) {
                    if (d = o(e, l = n(e)), b = p.test(d.prefix) || p.test(d.postfix), d.isPicture && (c = e.parentNode))
                        for (h = c.getElementsByTagName("source"), u = 0, f = h.length; f > u; u++)(b || p.test(v = n(h[u]))) && (s(v, d, h[u]), S = !0);
                    b || p.test(l) ? (s(l, d, e), S = !0) : S && ((k = []).srcset = [], k.isPicture = !0, Object.defineProperty(e, "_lazyrias", {
                        value: k,
                        writable: !0
                    })), S && (w ? e.removeAttribute(r.srcAttr) : "auto" != m && (y = {
                        width: parseInt(m, 10)
                    }, _({
                        target: e,
                        detail: y
                    })))
                }
            }, !0);
            var b, S, k, C, _ = (b = function(t, e) {
                return t.w - e.w
            }, S = function(t, e) {
                var s;
                return !t._lazyrias && i.pWS && (s = i.pWS(t.getAttribute(r.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
                    value: s,
                    writable: !0
                }), e && t.parentNode && (s.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())), t._lazyrias
            }, k = function(e, s) {
                var o, n, r, a, l, d, c, p, h;
                if ((l = e._lazyrias).isPicture && t.matchMedia)
                    for (n = 0, o = e.parentNode.getElementsByTagName("source"), r = o.length; r > n; n++)
                        if (S(o[n]) && !o[n].getAttribute("type") && (!(a = o[n].getAttribute("media")) || (matchMedia(a) || {}).matches)) {
                            l = o[n]._lazyrias;
                            break
                        } return (!l.w || l.w < s) && (l.w = s, l.d = (c = e, p = t.devicePixelRatio || 1, h = i.getX && i.getX(c), Math.min(h || p, 2.4, p)), d = function(t) {
                    for (var e, i, s = t.length, o = t[s - 1], n = 0; s > n; n++)
                        if (o = t[n], o.d = o.w / t.w, o.d >= t.d) {
                            !o.cached && (e = t[n - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (o.d - t.d) * i > t.d && (o = e));
                            break
                        } return o
                }(l.sort(b))), d
            }, C = function(s) {
                if (s.detail.instance == i) {
                    var o, n = s.target;
                    return !y && (t.respimage || t.picturefill || lazySizesConfig.pf) ? void e.removeEventListener("lazybeforesizes", C) : void(("_lazyrias" in n || s.detail.dataAttr && S(n, !0)) && (o = k(n, s.detail.width), o && o.u && n._lazyrias.cur != o.u && (n._lazyrias.cur = o.u, o.cached = !0, i.rAF(function() {
                        n.setAttribute(r.srcAttr, o.u), n.setAttribute("src", o.u)
                    }))))
                }
            }, w ? C = function() {} : addEventListener("lazybeforesizes", C), C)
        }).bind(null, s, s.document), "object" == typeof module && module.exports ? o(require("lazysizes")) : s.lazySizes ? n() : s.addEventListener("lazyunveilread", n, !0),
        function(t, e, i) {
            "use strict";
            if (t.addEventListener) {
                var s, o = /^picture$/i,
                    n = e.documentElement,
                    r = (v = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g, m = function(t, e, i, s, o, n, r, a) {
                        g.push({
                            c: e,
                            u: i,
                            w: 1 * ("w" == a ? r : s)
                        })
                    }, function(t) {
                        return g = [], t.replace(v, m), g
                    }),
                    a = (u = function(t, e) {
                        return t.w - e.w
                    }, f = function(t, e) {
                        var i = {
                                srcset: t.getAttribute(lazySizes.cfg.srcsetAttr) || ""
                            },
                            s = r(i.srcset);
                        return Object.defineProperty(t, e, {
                            value: i,
                            writable: !0
                        }), i.cands = s, i.index = 0, i.dirty = !1, s[0] && s[0].w ? (s.sort(u), i.cSrcset = [s[i.index].c]) : (i.cSrcset = i.srcset ? [i.srcset] : [], i.cands = []), i
                    }, function(t, e) {
                        var i, s, n, r;
                        if (!t[e] && (r = t.parentNode || {}, t[e] = f(t, e), t[e].isImg = !0, o.test(r.nodeName || "")))
                            for (t[e].picture = !0, i = r.getElementsByTagName("source"), s = 0, n = i.length; n > s; s++) f(i[s], e).isImg = !1;
                        return t[e]
                    }),
                    l = {
                        _lazyOptimumx: function(t, e, i) {
                            var s, o, n, r, a, l, d;
                            for (s = 0; s < t.cands.length; s++)
                                if (o = t.cands[s], o.d = (o.w || 1) / e, !(t.index >= s)) {
                                    if (!(o.d <= i) && (n = t.cands[s - 1], r = o.d, a = i, l = void 0, d = void 0, n && n.d && (d = a > .7 ? .6 : .4, n.d >= a || (.1 > (l = Math.pow(n.d - d, 1.6) || .1) ? l = .1 : l > 3 && (l = 3), !(a > n.d + (r - a) * l))))) break;
                                    t.cSrcset.push(o.c), t.index = s
                                }
                        }
                    },
                    d = (h = function(t, e, i, s, o) {
                        var n, r = t[o];
                        r && (n = r.index, l[o](r, e, i), r.dirty && n == r.index || (r.cSrcset.join(", "), t.setAttribute(s, r.cSrcset.join(", ")), r.dirty = !0))
                    }, function(t, e, i, s, o) {
                        var n, r, a, l, d = t[o];
                        if (d.width = e, d.picture && (r = t.parentNode))
                            for (n = r.getElementsByTagName("source"), l = 0, a = n.length; a > l; l++) h(n[l], e, i, s, o);
                        h(t, e, i, s, o)
                    }),
                    c = function(t) {
                        var e = t.getAttribute("data-optimumx") || t.getAttribute("data-maxdpr");
                        return !e && s.constrainPixelDensity && (e = "auto"), e && (e = "auto" == e ? s.getOptimumX(t) : parseFloat(e, 10)), e
                    },
                    p = function() {
                        t.lazySizes && !t.lazySizes.getOptimumX && (lazySizes.getX = c, lazySizes.pWS = r, n.removeEventListener("lazybeforeunveil", p))
                    };
                n.addEventListener("lazybeforeunveil", p), setTimeout(p), (s = t.lazySizes && lazySizes.cfg || t.lazySizesConfig) || (s = {}, t.lazySizesConfig = s), "function" != typeof s.getOptimumX && (s.getOptimumX = function() {
                    var e = t.devicePixelRatio || 1;
                    return e > 2.6 ? e *= .6 : e > 1.9 ? e *= .8 : e -= .01, Math.min(Math.round(100 * e) / 100, 2)
                }), t.devicePixelRatio && addEventListener("lazybeforesizes", function(t) {
                    var e, i, o, n, r = t.target,
                        l = t.detail,
                        p = l.dataAttr;
                    t.defaultPrevented || !(e = c(r)) || e >= devicePixelRatio || (!p || !r._lazyOptimumx || l.reloaded || s.unloadedClass && lazySizes.hC(r, s.unloadedClass) || (r._lazyOptimumx = null), i = a(r, "_lazyOptimumx"), (o = l.width) && (i.width || 0) < o && (n = p ? lazySizes.cfg.srcsetAttr : "srcset", lazySizes.rAF(function() {
                        d(r, o, e, n, "_lazyOptimumx")
                    })))
                })
            }
            var h, u, f, g, v, m
        }(window, document), r = window, l = function() {
            a(r.lazySizes), r.removeEventListener("lazyunveilread", l, !0)
        }, a = (a = function(t, e, i) {
            "use strict";
            var s, o;
            "srcset" in e.createElement("img") && (s = /^img$/i, o = function(t) {
                t.target.style.backgroundSize = "", t.target.style.backgroundImage = "", t.target.removeEventListener(t.type, o)
            }, e.addEventListener("lazybeforeunveil", function(t) {
                if (t.detail.instance == i) {
                    var e = t.target;
                    if (s.test(e.nodeName)) {
                        var n = e.getAttribute("src");
                        n && (e.style.backgroundSize = "100% 100%", e.style.backgroundImage = "url(" + n + ")", e.removeAttribute("src"), e.addEventListener("load", o))
                    }
                }
            }, !1))
        }).bind(null, r, r.document), "object" == typeof module && module.exports ? a(require("lazysizes")) : r.lazySizes ? l() : r.addEventListener("lazyunveilread", l, !0), d = window, p = function() {
            c(d.lazySizes), d.removeEventListener("lazyunveilread", p, !0)
        }, c = (c = function(t, e, i) {
            "use strict";
            if (t.addEventListener) {
                var s = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                    o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                    n = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                    r = /^picture$/i,
                    a = {
                        getParent: function(e, i) {
                            var s = e,
                                o = e.parentNode;
                            return i && "prev" != i || !o || !r.test(o.nodeName || "") || (o = o.parentNode), "self" != i && (s = "prev" == i ? e.previousElementSibling : i && (o.closest || t.jQuery) && (o.closest ? o.closest(i) : jQuery(o).closest(i)[0]) || o), s
                        },
                        getFit: function(t) {
                            var e, i, s = getComputedStyle(t, null) || {},
                                r = s.content || s.fontFamily,
                                l = {
                                    fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit")
                                };
                            return !l.fit && r && (e = r.match(o)) && (l.fit = e[1]), l.fit ? (!(i = t._lazysizesParentContainer || t.getAttribute("data-parent-container")) && r && (e = r.match(n)) && (i = e[1]), l.parent = a.getParent(t, i)) : l.fit = s.objectFit, l
                        },
                        getImageRatio: function(e) {
                            var i, o, n, a, l = e.parentNode,
                                d = l && r.test(l.nodeName || "") ? l.querySelectorAll("source, img") : [e];
                            for (i = 0; i < d.length; i++)
                                if (e = d[i], o = e.getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "", n = e._lsMedia || e.getAttribute("media"), n = lazySizesConfig.customMedia[e.getAttribute("data-media") || n] || n, o && (!n || (t.matchMedia && matchMedia(n) || {}).matches)) {
                                    !(a = parseFloat(e.getAttribute("data-aspectratio"))) && o.match(s) && (a = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                                    break
                                } return a
                        },
                        calculateSize: function(t, e) {
                            var i, s, o, n, r = this.getFit(t),
                                a = r.fit,
                                l = r.parent;
                            return "width" == a || ("contain" == a || "cover" == a) && (o = this.getImageRatio(t)) ? (l ? e = l.clientWidth : l = t, n = e, "width" == a ? n = e : (s = l.clientHeight) > 40 && (i = e / s) && ("cover" == a && o > i || "contain" == a && i > o) && (n = e * (o / i)), n) : e
                        }
                    };
                i.parentFit = a, e.addEventListener("lazybeforesizes", function(t) {
                    if (!t.defaultPrevented && t.detail.instance == i) {
                        var e = t.target;
                        t.detail.width = a.calculateSize(e, t.detail.width)
                    }
                })
            }
        }).bind(null, d, d.document), "object" == typeof module && module.exports ? c(require("lazysizes")) : d.lazySizes ? p() : d.addEventListener("lazyunveilread", p, !0), h = window, f = function() {
            u(h.lazySizes), h.removeEventListener("lazyunveilread", f, !0)
        }, u = (u = function(t, e, i) {
            "use strict";
            var s, o, n, r, a, l, d, c, p, h, u, f, g, v, m, y, w = i && i.cfg || t.lazySizesConfig,
                b = e.createElement("img"),
                S = "sizes" in b && "srcset" in b,
                k = /\s+\d+h/g,
                C = (o = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, n = Array.prototype.forEach, function(t) {
                    var i = e.createElement("img"),
                        s = function(t) {
                            var e, i, s = t.getAttribute(lazySizesConfig.srcsetAttr);
                            s && ((i = s.match(o)) && (e = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) && t.setAttribute("data-aspectratio", e), t.setAttribute(lazySizesConfig.srcsetAttr, s.replace(k, "")))
                        },
                        r = function(t) {
                            var e = t.target.parentNode;
                            e && "PICTURE" == e.nodeName && n.call(e.getElementsByTagName("source"), s), s(t.target)
                        },
                        a = function() {
                            i.currentSrc && e.removeEventListener("lazybeforeunveil", r)
                        };
                    t[1] && (e.addEventListener("lazybeforeunveil", r), i.onload = a, i.onerror = a, i.srcset = "data:,a 1w 1h", i.complete && a())
                });
            if (w || (w = {}, t.lazySizesConfig = w), w.supportsType || (w.supportsType = function(t) {
                    return !t
                }), !t.picturefill && !w.pf) {
                if (t.HTMLPictureElement && S) return e.msElementsFromPoint && C(navigator.userAgent.match(/Edge\/(\d+)/)), void(w.pf = function() {});
                w.pf = function(e) {
                    var i, o;
                    if (!t.picturefill)
                        for (i = 0, o = e.elements.length; o > i; i++) s(e.elements[i])
                }, p = function(t, e) {
                    return t.w - e.w
                }, h = /^\s*\d+\.*\d*px\s*$/, l = /(([^,\s].[^\s]+)\s+(\d+)w)/g, d = /\s/, c = function(t, e, i, s) {
                    a.push({
                        c: e,
                        u: i,
                        w: 1 * s
                    })
                }, f = function() {
                    var t, i, o;
                    f.init || (f.init = !0, addEventListener("resize", (i = e.getElementsByClassName("lazymatchmedia"), o = function() {
                        var t, e;
                        for (t = 0, e = i.length; e > t; t++) s(i[t])
                    }, function() {
                        clearTimeout(t), t = setTimeout(o, 66)
                    })))
                }, g = function(e, s) {
                    var o, n = e.getAttribute("srcset") || e.getAttribute(w.srcsetAttr);
                    !n && s && (n = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(w.srcAttr) || e.getAttribute("src")), e._lazypolyfill && e._lazypolyfill._set == n || (o = u(n || ""), s && e.parentNode && (o.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(), o.isPicture && t.matchMedia && (i.aC(e, "lazymatchmedia"), f())), o._set = n, Object.defineProperty(e, "_lazypolyfill", {
                        value: o,
                        writable: !0
                    }))
                }, v = function(e) {
                    return t.matchMedia ? (v = function(t) {
                        return !t || (matchMedia(t) || {}).matches
                    })(e) : !e
                }, m = function(e) {
                    var s, o, n, r, a, l, d, c, u, f;
                    if (g(r = e, !0), (a = r._lazypolyfill).isPicture)
                        for (o = 0, s = e.parentNode.getElementsByTagName("source"), n = s.length; n > o; o++)
                            if (w.supportsType(s[o].getAttribute("type"), e) && v(s[o].getAttribute("media"))) {
                                r = s[o], g(r), a = r._lazypolyfill;
                                break
                            } return a.length > 1 ? (d = r.getAttribute("sizes") || "", d = h.test(d) && parseInt(d, 10) || i.gW(e, e.parentNode), a.d = (c = e, u = t.devicePixelRatio || 1, f = i.getX && i.getX(c), Math.min(f || u, 2.5, u)), !a.src || !a.w || a.w < d ? (a.w = d, l = function(t) {
                        for (var e, i, s = t.length, o = t[s - 1], n = 0; s > n; n++)
                            if (o = t[n], o.d = o.w / t.w, o.d >= t.d) {
                                !o.cached && (e = t[n - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (o.d - t.d) * i > t.d && (o = e));
                                break
                            } return o
                    }(a.sort(p)), a.src = l) : l = a.src) : l = a[0], l
                }, (y = function(t) {
                    if (!S || !t.parentNode || "PICTURE" == t.parentNode.nodeName.toUpperCase()) {
                        var e = m(t);
                        e && e.u && t._lazypolyfill.cur != e.u && (t._lazypolyfill.cur = e.u, e.cached = !0, t.setAttribute(w.srcAttr, e.u), t.setAttribute("src", e.u))
                    }
                }).parse = u = function(t) {
                    return a = [], (t = t.trim()).replace(k, "").replace(l, c), a.length || !t || d.test(t) || a.push({
                        c: t,
                        u: t,
                        w: 99
                    }), a
                }, s = y, w.loadedClass && w.loadingClass && (r = [], ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(t) {
                    r.push(t + w.loadedClass), r.push(t + w.loadingClass)
                }), w.pf({
                    elements: e.querySelectorAll(r.join(", "))
                }))
            }
        }).bind(null, h, h.document), "object" == typeof module && module.exports ? u(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : h.lazySizes ? f() : h.addEventListener("lazyunveilread", f, !0), g = window, m = function() {
            v(g.lazySizes), g.removeEventListener("lazyunveilread", m, !0)
        }, v = (v = function(t, e, i) {
            "use strict";
            if (t.addEventListener) {
                var s = /\s+/g,
                    o = /\s*\|\s+|\s+\|\s*/g,
                    n = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                    r = /\(|\)|'/,
                    a = {
                        contain: 1,
                        cover: 1
                    },
                    l = function(t) {
                        if (t.target._lazybgset) {
                            var e = t.target,
                                s = e._lazybgset,
                                o = e.currentSrc || e.src;
                            o && (s.style.backgroundImage = "url(" + (r.test(o) ? JSON.stringify(o) : o) + ")"), e._lazybgsetLoading && (i.fire(s, "_lazyloaded", {}, !1, !0), delete e._lazybgsetLoading)
                        }
                    };
                addEventListener("lazybeforeunveil", function(t) {
                    var r, a, d, c, p, h, u, f, g, v;
                    !t.defaultPrevented && (r = t.target.getAttribute("data-bgset")) && (d = t.target, (a = e.createElement("img")).alt = "", a._lazybgsetLoading = !0, t.detail.firesLoad = !0, c = r, p = d, h = a, u = e.createElement("picture"), f = p.getAttribute(lazySizesConfig.sizesAttr), g = p.getAttribute("data-ratio"), v = p.getAttribute("data-optimumx"), p._lazybgset && p._lazybgset.parentNode == p && p.removeChild(p._lazybgset), Object.defineProperty(h, "_lazybgset", {
                        value: p,
                        writable: !0
                    }), Object.defineProperty(p, "_lazybgset", {
                        value: u,
                        writable: !0
                    }), c = c.replace(s, " ").split(o), u.style.display = "none", h.className = lazySizesConfig.lazyClass, 1 != c.length || f || (f = "auto"), c.forEach(function(t) {
                        var i = e.createElement("source");
                        f && "auto" != f && i.setAttribute("sizes", f), t.match(n) && (i.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && i.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)), u.appendChild(i)
                    }), f && (h.setAttribute(lazySizesConfig.sizesAttr, f), p.removeAttribute(lazySizesConfig.sizesAttr), p.removeAttribute("sizes")), v && h.setAttribute("data-optimumx", v), g && h.setAttribute("data-ratio", g), u.appendChild(h), p.appendChild(u), setTimeout(function() {
                        i.loader.unveil(a), i.rAF(function() {
                            i.fire(a, "_lazyloaded", {}, !0, !0), a.complete && l({
                                target: a
                            })
                        })
                    }))
                }), e.addEventListener("load", l, !0), t.addEventListener("lazybeforesizes", function(t) {
                    if (t.detail.instance == i && t.target._lazybgset && t.detail.dataAttr) {
                        var e = t.target._lazybgset,
                            s = (o = e, n = (getComputedStyle(o) || {
                                getPropertyValue: function() {}
                            }).getPropertyValue("background-size"), !a[n] && a[o.style.backgroundSize] && (n = o.style.backgroundSize), n);
                        a[s] && (t.target._lazysizesParentFit = s, i.rAF(function() {
                            t.target.setAttribute("data-parent-fit", s), t.target._lazysizesParentFit && delete t.target._lazysizesParentFit
                        }))
                    }
                    var o, n
                }, !0), e.documentElement.addEventListener("lazybeforesizes", function(t) {
                    var e, s;
                    !t.defaultPrevented && t.target._lazybgset && t.detail.instance == i && (t.detail.width = (e = t.target._lazybgset, s = i.gW(e, e.parentNode), (!e._lazysizesWidth || s > e._lazysizesWidth) && (e._lazysizesWidth = s), e._lazysizesWidth))
                })
            }
        }).bind(null, g, g.document), "object" == typeof module && module.exports ? v(require("lazysizes")) : g.lazySizes ? m() : g.addEventListener("lazyunveilread", m, !0), document.addEventListener("lazyloaded", function(t) {
            t.target.parentElement.className = t.target.parentElement.className.replace("lazyload--placeholder", "")
        }),
        function(t) {
            "use strict";
            "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
        }(function(t) {
            "use strict";
            var e = window.Slick || {};
            (e = function() {
                var e = 0;
                return function(i, s) {
                    var o, n = this;
                    n.defaults = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        appendArrows: t(i),
                        appendDots: t(i),
                        arrows: !0,
                        asNavFor: null,
                        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                        autoplay: !1,
                        autoplaySpeed: 3e3,
                        centerMode: !1,
                        centerPadding: "50px",
                        cssEase: "ease",
                        customPaging: function(e, i) {
                            return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1)
                        },
                        dots: !1,
                        dotsClass: "slick-dots",
                        draggable: !0,
                        easing: "linear",
                        edgeFriction: .35,
                        fade: !1,
                        focusOnSelect: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: "ondemand",
                        mobileFirst: !1,
                        pauseOnHover: !0,
                        pauseOnFocus: !0,
                        pauseOnDotsHover: !1,
                        respondTo: "window",
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: "",
                        slidesPerRow: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 500,
                        swipe: !0,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        verticalSwiping: !1,
                        waitForAnimate: !0,
                        zIndex: 1e3
                    }, n.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1
                    }, t.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = t(i), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, o = t(i).data("slick") || {}, n.options = t.extend({}, n.defaults, s, o), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = t.proxy(n.autoPlay, n), n.autoPlayClear = t.proxy(n.autoPlayClear, n), n.autoPlayIterator = t.proxy(n.autoPlayIterator, n), n.changeSlide = t.proxy(n.changeSlide, n), n.clickHandler = t.proxy(n.clickHandler, n), n.selectHandler = t.proxy(n.selectHandler, n), n.setPosition = t.proxy(n.setPosition, n), n.swipeHandler = t.proxy(n.swipeHandler, n), n.dragHandler = t.proxy(n.dragHandler, n), n.keyHandler = t.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
                }
            }()).prototype.activateADA = function() {
                this.$slideTrack.find(".slick-active").attr({
                    "aria-hidden": "false"
                }).find("a, input, button, select").attr({
                    tabindex: "0"
                })
            }, e.prototype.addSlide = e.prototype.slickAdd = function(e, i, s) {
                var o = this;
                if ("boolean" == typeof i) s = i, i = null;
                else if (0 > i || i >= o.slideCount) return !1;
                o.unload(), "number" == typeof i ? 0 === i && 0 === o.$slides.length ? t(e).appendTo(o.$slideTrack) : s ? t(e).insertBefore(o.$slides.eq(i)) : t(e).insertAfter(o.$slides.eq(i)) : !0 === s ? t(e).prependTo(o.$slideTrack) : t(e).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(e, i) {
                    t(i).attr("data-slick-index", e)
                }), o.$slidesCache = o.$slides, o.reinit()
            }, e.prototype.animateHeight = function() {
                var t = this;
                if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.animate({
                        height: e
                    }, t.options.speed)
                }
            }, e.prototype.animateSlide = function(e, i) {
                var s = {},
                    o = this;
                o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (e = -e), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
                    left: e
                }, o.options.speed, o.options.easing, i) : o.$slideTrack.animate({
                    top: e
                }, o.options.speed, o.options.easing, i) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), t({
                    animStart: o.currentLeft
                }).animate({
                    animStart: e
                }, {
                    duration: o.options.speed,
                    easing: o.options.easing,
                    step: function(t) {
                        t = Math.ceil(t), !1 === o.options.vertical ? (s[o.animType] = "translate(" + t + "px, 0px)", o.$slideTrack.css(s)) : (s[o.animType] = "translate(0px," + t + "px)", o.$slideTrack.css(s))
                    },
                    complete: function() {
                        i && i.call()
                    }
                })) : (o.applyTransition(), e = Math.ceil(e), !1 === o.options.vertical ? s[o.animType] = "translate3d(" + e + "px, 0px, 0px)" : s[o.animType] = "translate3d(0px," + e + "px, 0px)", o.$slideTrack.css(s), i && setTimeout(function() {
                    o.disableTransition(), i.call()
                }, o.options.speed))
            }, e.prototype.getNavTarget = function() {
                var e = this.options.asNavFor;
                return e && null !== e && (e = t(e).not(this.$slider)), e
            }, e.prototype.asNavFor = function(e) {
                var i = this.getNavTarget();
                null !== i && "object" == typeof i && i.each(function() {
                    var i = t(this).slick("getSlick");
                    i.unslicked || i.slideHandler(e, !0)
                })
            }, e.prototype.applyTransition = function(t) {
                var e = this,
                    i = {};
                !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
            }, e.prototype.autoPlay = function() {
                var t = this;
                t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
            }, e.prototype.autoPlayClear = function() {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer)
            }, e.prototype.autoPlayIterator = function() {
                var t = this,
                    e = t.currentSlide + t.options.slidesToScroll;
                t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, t.currentSlide - 1 == 0 && (t.direction = 1))), t.slideHandler(e))
            }, e.prototype.buildArrows = function() {
                var e = this;
                !0 === e.options.arrows && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                    "aria-disabled": "true",
                    tabindex: "-1"
                }))
            }, e.prototype.buildDots = function() {
                var e, i, s = this;
                if (!0 === s.options.dots && s.slideCount > s.options.slidesToShow) {
                    for (s.$slider.addClass("slick-dotted"), i = t("<ul />").addClass(s.options.dotsClass), e = 0; e <= s.getDotCount(); e += 1) i.append(t("<li />").append(s.options.customPaging.call(this, s, e)));
                    s.$dots = i.appendTo(s.options.appendDots), s.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
                }
            }, e.prototype.buildOut = function() {
                var e = this;
                e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
                    t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "")
                }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), (!0 === e.options.centerMode || !0 === e.options.swipeToSlide) && (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
            }, e.prototype.buildRows = function() {
                var t, e, i, s, o, n, r, a = this;
                if (s = document.createDocumentFragment(), n = a.$slider.children(), a.options.rows > 1) {
                    for (r = a.options.slidesPerRow * a.options.rows, o = Math.ceil(n.length / r), t = 0; o > t; t++) {
                        var l = document.createElement("div");
                        for (e = 0; e < a.options.rows; e++) {
                            var d = document.createElement("div");
                            for (i = 0; i < a.options.slidesPerRow; i++) {
                                var c = t * r + (e * a.options.slidesPerRow + i);
                                n.get(c) && d.appendChild(n.get(c))
                            }
                            l.appendChild(d)
                        }
                        s.appendChild(l)
                    }
                    a.$slider.empty().append(s), a.$slider.children().children().children().css({
                        width: 100 / a.options.slidesPerRow + "%",
                        display: "inline-block"
                    })
                }
            }, e.prototype.checkResponsive = function(e, i) {
                var s, o, n, r = this,
                    a = !1,
                    l = r.$slider.width(),
                    d = window.innerWidth || t(window).width();
                if ("window" === r.respondTo ? n = d : "slider" === r.respondTo ? n = l : "min" === r.respondTo && (n = Math.min(d, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
                    o = null;
                    for (s in r.breakpoints) r.breakpoints.hasOwnProperty(s) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[s] && (o = r.breakpoints[s]) : n > r.breakpoints[s] && (o = r.breakpoints[s]));
                    null !== o ? null !== r.activeBreakpoint ? (o !== r.activeBreakpoint || i) && (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : (r.activeBreakpoint = o, "unslick" === r.breakpointSettings[o] ? r.unslick(o) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[o]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = o) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), a = o), e || !1 === a || r.$slider.trigger("breakpoint", [r, a])
                }
            }, e.prototype.changeSlide = function(e, i) {
                var s, o, n = this,
                    r = t(e.currentTarget);
                switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), s = n.slideCount % n.options.slidesToScroll != 0 ? 0 : (n.slideCount - n.currentSlide) % n.options.slidesToScroll, e.data.message) {
                    case "previous":
                        o = 0 === s ? n.options.slidesToScroll : n.options.slidesToShow - s, n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide - o, !1, i);
                        break;
                    case "next":
                        o = 0 === s ? n.options.slidesToScroll : s, n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide + o, !1, i);
                        break;
                    case "index":
                        var a = 0 === e.data.index ? 0 : e.data.index || r.index() * n.options.slidesToScroll;
                        n.slideHandler(n.checkNavigable(a), !1, i), r.children().trigger("focus");
                        break;
                    default:
                        return
                }
            }, e.prototype.checkNavigable = function(t) {
                var e, i;
                if (i = 0, t > (e = this.getNavigableIndexes())[e.length - 1]) t = e[e.length - 1];
                else
                    for (var s in e) {
                        if (t < e[s]) {
                            t = i;
                            break
                        }
                        i = e[s]
                    }
                return t
            }, e.prototype.cleanUpEvents = function() {
                var e = this;
                e.options.dots && null !== e.$dots && t("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", t.proxy(e.interrupt, e, !0)).off("mouseleave.slick", t.proxy(e.interrupt, e, !1)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), t(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().off("click.slick", e.selectHandler), t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), t(window).off("resize.slick.slick-" + e.instanceUid, e.resize), t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
            }, e.prototype.cleanUpSlideEvents = function() {
                var e = this;
                e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1))
            }, e.prototype.cleanUpRows = function() {
                var t;
                this.options.rows > 1 && ((t = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(t))
            }, e.prototype.clickHandler = function(t) {
                !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
            }, e.prototype.destroy = function(e) {
                var i = this;
                i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                    t(this).attr("style", t(this).data("originalStyling"))
                }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), i.unslicked = !0, e || i.$slider.trigger("destroy", [i])
            }, e.prototype.disableTransition = function(t) {
                var e = {};
                e[this.transitionType] = "", !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e)
            }, e.prototype.fadeSlide = function(t, e) {
                var i = this;
                !1 === i.cssTransitions ? (i.$slides.eq(t).css({
                    zIndex: i.options.zIndex
                }), i.$slides.eq(t).animate({
                    opacity: 1
                }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
                    opacity: 1,
                    zIndex: i.options.zIndex
                }), e && setTimeout(function() {
                    i.disableTransition(t), e.call()
                }, i.options.speed))
            }, e.prototype.fadeSlideOut = function(t) {
                var e = this;
                !1 === e.cssTransitions ? e.$slides.eq(t).animate({
                    opacity: 0,
                    zIndex: e.options.zIndex - 2
                }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({
                    opacity: 0,
                    zIndex: e.options.zIndex - 2
                }))
            }, e.prototype.filterSlides = e.prototype.slickFilter = function(t) {
                var e = this;
                null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
            }, e.prototype.focusHandler = function() {
                var e = this;
                e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(i) {
                    i.stopImmediatePropagation();
                    var s = t(this);
                    setTimeout(function() {
                        e.options.pauseOnFocus && (e.focussed = s.is(":focus"), e.autoPlay())
                    }, 0)
                })
            }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
                return this.currentSlide
            }, e.prototype.getDotCount = function() {
                var t = this,
                    e = 0,
                    i = 0,
                    s = 0;
                if (!0 === t.options.infinite)
                    for (; e < t.slideCount;) ++s, e = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
                else if (!0 === t.options.centerMode) s = t.slideCount;
                else if (t.options.asNavFor)
                    for (; e < t.slideCount;) ++s, e = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
                else s = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
                return s - 1
            }, e.prototype.getLeft = function(t) {
                var e, i, s, o = this,
                    n = 0;
                return o.slideOffset = 0, i = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, n = i * o.options.slidesToShow * -1), o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (t > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1, n = (o.options.slidesToShow - (t - o.slideCount)) * i * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, n = o.slideCount % o.options.slidesToScroll * i * -1))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth, n = (t + o.options.slidesToShow - o.slideCount) * i), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, n = 0), !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), e = !1 === o.options.vertical ? t * o.slideWidth * -1 + o.slideOffset : t * i * -1 + n, !0 === o.options.variableWidth && (s = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow), e = !0 === o.options.rtl ? s[0] ? -1 * (o.$slideTrack.width() - s[0].offsetLeft - s.width()) : 0 : s[0] ? -1 * s[0].offsetLeft : 0, !0 === o.options.centerMode && (s = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1), e = !0 === o.options.rtl ? s[0] ? -1 * (o.$slideTrack.width() - s[0].offsetLeft - s.width()) : 0 : s[0] ? -1 * s[0].offsetLeft : 0, e += (o.$list.width() - s.outerWidth()) / 2)), e
            }, e.prototype.getOption = e.prototype.slickGetOption = function(t) {
                return this.options[t]
            }, e.prototype.getNavigableIndexes = function() {
                var t, e = this,
                    i = 0,
                    s = 0,
                    o = [];
                for (!1 === e.options.infinite ? t = e.slideCount : (i = -1 * e.options.slidesToScroll, s = -1 * e.options.slidesToScroll, t = 2 * e.slideCount); t > i;) o.push(i), i = s + e.options.slidesToScroll, s += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                return o
            }, e.prototype.getSlick = function() {
                return this
            }, e.prototype.getSlideCount = function() {
                var e, i, s = this;
                return i = !0 === s.options.centerMode ? s.slideWidth * Math.floor(s.options.slidesToShow / 2) : 0, !0 === s.options.swipeToSlide ? (s.$slideTrack.find(".slick-slide").each(function(o, n) {
                    return n.offsetLeft - i + t(n).outerWidth() / 2 > -1 * s.swipeLeft ? (e = n, !1) : void 0
                }), Math.abs(t(e).attr("data-slick-index") - s.currentSlide) || 1) : s.options.slidesToScroll
            }, e.prototype.goTo = e.prototype.slickGoTo = function(t, e) {
                this.changeSlide({
                    data: {
                        message: "index",
                        index: parseInt(t)
                    }
                }, e)
            }, e.prototype.init = function(e) {
                var i = this;
                t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), e && i.$slider.trigger("init", [i]), !0 === i.options.accessibility && i.initADA(), i.options.autoplay && (i.paused = !1, i.autoPlay())
            }, e.prototype.initADA = function() {
                var e = this;
                e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
                    "aria-hidden": "true",
                    tabindex: "-1"
                }).find("a, input, button, select").attr({
                    tabindex: "-1"
                }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
                    t(this).attr({
                        role: "option",
                        "aria-describedby": "slick-slide" + e.instanceUid + i
                    })
                }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
                    t(this).attr({
                        role: "presentation",
                        "aria-selected": "false",
                        "aria-controls": "navigation" + e.instanceUid + i,
                        id: "slick-slide" + e.instanceUid + i
                    })
                }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA()
            }, e.prototype.initArrowEvents = function() {
                var t = this;
                !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
                    message: "previous"
                }, t.changeSlide), t.$nextArrow.off("click.slick").on("click.slick", {
                    message: "next"
                }, t.changeSlide))
            }, e.prototype.initDotEvents = function() {
                var e = this;
                !0 === e.options.dots && e.slideCount > e.options.slidesToShow && t("li", e.$dots).on("click.slick", {
                    message: "index"
                }, e.changeSlide), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.interrupt, e, !0)).on("mouseleave.slick", t.proxy(e.interrupt, e, !1))
            }, e.prototype.initSlideEvents = function() {
                var e = this;
                e.options.pauseOnHover && (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)))
            }, e.prototype.initializeEvents = function() {
                var e = this;
                e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
                    action: "start"
                }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
                    action: "move"
                }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
                    action: "end"
                }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
                    action: "end"
                }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), t(document).on(e.visibilityChange, t.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)), t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)), t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
            }, e.prototype.initUI = function() {
                var t = this;
                !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), t.$nextArrow.show()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show()
            }, e.prototype.keyHandler = function(t) {
                var e = this;
                t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === e.options.accessibility ? e.changeSlide({
                    data: {
                        message: !0 === e.options.rtl ? "next" : "previous"
                    }
                }) : 39 === t.keyCode && !0 === e.options.accessibility && e.changeSlide({
                    data: {
                        message: !0 === e.options.rtl ? "previous" : "next"
                    }
                }))
            }, e.prototype.lazyLoad = function() {
                function e(e) {
                    t("img[data-lazy]", e).each(function() {
                        var e = t(this),
                            i = t(this).attr("data-lazy"),
                            s = document.createElement("img");
                        s.onload = function() {
                            e.animate({
                                opacity: 0
                            }, 100, function() {
                                e.attr("src", i).animate({
                                    opacity: 1
                                }, 200, function() {
                                    e.removeAttr("data-lazy").removeClass("slick-loading")
                                }), o.$slider.trigger("lazyLoaded", [o, e, i])
                            })
                        }, s.onerror = function() {
                            e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, e, i])
                        }, s.src = i
                    })
                }
                var i, s, o = this;
                !0 === o.options.centerMode ? !0 === o.options.infinite ? s = (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)), s = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide, s = Math.ceil(i + o.options.slidesToShow), !0 === o.options.fade && (i > 0 && i--, s <= o.slideCount && s++)), e(o.$slider.find(".slick-slide").slice(i, s)), o.slideCount <= o.options.slidesToShow ? e(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? e(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && e(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow))
            }, e.prototype.loadSlider = function() {
                var t = this;
                t.setPosition(), t.$slideTrack.css({
                    opacity: 1
                }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
            }, e.prototype.next = e.prototype.slickNext = function() {
                this.changeSlide({
                    data: {
                        message: "next"
                    }
                })
            }, e.prototype.orientationChange = function() {
                this.checkResponsive(), this.setPosition()
            }, e.prototype.pause = e.prototype.slickPause = function() {
                this.autoPlayClear(), this.paused = !0
            }, e.prototype.play = e.prototype.slickPlay = function() {
                var t = this;
                t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1
            }, e.prototype.postSlide = function(t) {
                var e = this;
                e.unslicked || (e.$slider.trigger("afterChange", [e, t]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA())
            }, e.prototype.prev = e.prototype.slickPrev = function() {
                this.changeSlide({
                    data: {
                        message: "previous"
                    }
                })
            }, e.prototype.preventDefault = function(t) {
                t.preventDefault()
            }, e.prototype.progressiveLazyLoad = function(e) {
                e = e || 1;
                var i, s, o, n = this,
                    r = t("img[data-lazy]", n.$slider);
                r.length ? (i = r.first(), s = i.attr("data-lazy"), (o = document.createElement("img")).onload = function() {
                    i.attr("src", s).removeAttr("data-lazy").removeClass("slick-loading"), !0 === n.options.adaptiveHeight && n.setPosition(), n.$slider.trigger("lazyLoaded", [n, i, s]), n.progressiveLazyLoad()
                }, o.onerror = function() {
                    3 > e ? setTimeout(function() {
                        n.progressiveLazyLoad(e + 1)
                    }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, i, s]), n.progressiveLazyLoad())
                }, o.src = s) : n.$slider.trigger("allImagesLoaded", [n])
            }, e.prototype.refresh = function(e) {
                var i, s, o = this;
                s = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > s && (o.currentSlide = s), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), i = o.currentSlide, o.destroy(!0), t.extend(o, o.initials, {
                    currentSlide: i
                }), o.init(), e || o.changeSlide({
                    data: {
                        message: "index",
                        index: i
                    }
                }, !1)
            }, e.prototype.registerBreakpoints = function() {
                var e, i, s, o = this,
                    n = o.options.responsive || null;
                if ("array" === t.type(n) && n.length) {
                    o.respondTo = o.options.respondTo || "window";
                    for (e in n)
                        if (s = o.breakpoints.length - 1, i = n[e].breakpoint, n.hasOwnProperty(e)) {
                            for (; s >= 0;) o.breakpoints[s] && o.breakpoints[s] === i && o.breakpoints.splice(s, 1), s--;
                            o.breakpoints.push(i), o.breakpointSettings[i] = n[e].settings
                        } o.breakpoints.sort(function(t, e) {
                        return o.options.mobileFirst ? t - e : e - t
                    })
                }
            }, e.prototype.reinit = function() {
                var e = this;
                e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
            }, e.prototype.resize = function() {
                var e = this;
                t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
                    e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
                }, 50))
            }, e.prototype.removeSlide = e.prototype.slickRemove = function(t, e, i) {
                var s = this;
                return "boolean" == typeof t ? t = !0 === (e = t) ? 0 : s.slideCount - 1 : t = !0 === e ? --t : t, !(s.slideCount < 1 || 0 > t || t > s.slideCount - 1) && (s.unload(), !0 === i ? s.$slideTrack.children().remove() : s.$slideTrack.children(this.options.slide).eq(t).remove(), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slidesCache = s.$slides, void s.reinit())
            }, e.prototype.setCSS = function(t) {
                var e, i, s = this,
                    o = {};
                !0 === s.options.rtl && (t = -t), e = "left" == s.positionProp ? Math.ceil(t) + "px" : "0px", i = "top" == s.positionProp ? Math.ceil(t) + "px" : "0px", o[s.positionProp] = t, !1 === s.transformsEnabled ? s.$slideTrack.css(o) : (o = {}, !1 === s.cssTransitions ? (o[s.animType] = "translate(" + e + ", " + i + ")", s.$slideTrack.css(o)) : (o[s.animType] = "translate3d(" + e + ", " + i + ", 0px)", s.$slideTrack.css(o)))
            }, e.prototype.setDimensions = function() {
                var t = this;
                !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
                    padding: "0px " + t.options.centerPadding
                }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), !0 === t.options.centerMode && t.$list.css({
                    padding: t.options.centerPadding + " 0px"
                })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
                var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
                !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
            }, e.prototype.setFade = function() {
                var e, i = this;
                i.$slides.each(function(s, o) {
                    e = i.slideWidth * s * -1, !0 === i.options.rtl ? t(o).css({
                        position: "relative",
                        right: e,
                        top: 0,
                        zIndex: i.options.zIndex - 2,
                        opacity: 0
                    }) : t(o).css({
                        position: "relative",
                        left: e,
                        top: 0,
                        zIndex: i.options.zIndex - 2,
                        opacity: 0
                    })
                }), i.$slides.eq(i.currentSlide).css({
                    zIndex: i.options.zIndex - 1,
                    opacity: 1
                })
            }, e.prototype.setHeight = function() {
                var t = this;
                if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.css("height", e)
                }
            }, e.prototype.setOption = e.prototype.slickSetOption = function() {
                var e, i, s, o, n, r = this,
                    a = !1;
                if ("object" === t.type(arguments[0]) ? (s = arguments[0], a = arguments[1], n = "multiple") : "string" === t.type(arguments[0]) && (s = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[s] = o;
                else if ("multiple" === n) t.each(s, function(t, e) {
                    r.options[t] = e
                });
                else if ("responsive" === n)
                    for (i in o)
                        if ("array" !== t.type(r.options.responsive)) r.options.responsive = [o[i]];
                        else {
                            for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === o[i].breakpoint && r.options.responsive.splice(e, 1), e--;
                            r.options.responsive.push(o[i])
                        } a && (r.unload(), r.reinit())
            }, e.prototype.setPosition = function() {
                var t = this;
                t.setDimensions(), t.setHeight(), !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), t.$slider.trigger("setPosition", [t])
            }, e.prototype.setProps = function() {
                var t = this,
                    e = document.body.style;
                t.positionProp = !0 === t.options.vertical ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && !0 === t.options.useCSS && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
            }, e.prototype.setSlideClasses = function(t) {
                var e, i, s, o, n = this;
                i = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(t).addClass("slick-current"), !0 === n.options.centerMode ? (e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (t >= e && t <= n.slideCount - 1 - e ? n.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (s = n.options.slidesToShow + t, i.slice(s - e + 1, s + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? i.eq(i.length - 1 - n.options.slidesToShow).addClass("slick-center") : t === n.slideCount - 1 && i.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(t, t + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= n.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = n.slideCount % n.options.slidesToShow, s = !0 === n.options.infinite ? n.options.slidesToShow + t : t, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - t < n.options.slidesToShow ? i.slice(s - (n.options.slidesToShow - o), s + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(s, s + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === n.options.lazyLoad && n.lazyLoad()
            }, e.prototype.setupInfinite = function() {
                var e, i, s, o = this;
                if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (i = null, o.slideCount > o.options.slidesToShow)) {
                    for (s = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, e = o.slideCount; e > o.slideCount - s; e -= 1) i = e - 1, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
                    for (e = 0; s > e; e += 1) i = e, t(o.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
                    o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                        t(this).attr("id", "")
                    })
                }
            }, e.prototype.interrupt = function(t) {
                t || this.autoPlay(), this.interrupted = t
            }, e.prototype.selectHandler = function(e) {
                var i = this,
                    s = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide"),
                    o = parseInt(s.attr("data-slick-index"));
                return o || (o = 0), i.slideCount <= i.options.slidesToShow ? (i.setSlideClasses(o), void i.asNavFor(o)) : void i.slideHandler(o)
            }, e.prototype.slideHandler = function(t, e, i) {
                var s, o, n, r, a, l = null,
                    d = this;
                return e = e || !1, !0 === d.animating && !0 === d.options.waitForAnimate || !0 === d.options.fade && d.currentSlide === t || d.slideCount <= d.options.slidesToShow ? void 0 : (!1 === e && d.asNavFor(t), s = t, l = d.getLeft(s), r = d.getLeft(d.currentSlide), d.currentLeft = null === d.swipeLeft ? r : d.swipeLeft, !1 === d.options.infinite && !1 === d.options.centerMode && (0 > t || t > d.getDotCount() * d.options.slidesToScroll) ? void(!1 === d.options.fade && (s = d.currentSlide, !0 !== i ? d.animateSlide(r, function() {
                    d.postSlide(s)
                }) : d.postSlide(s))) : !1 === d.options.infinite && !0 === d.options.centerMode && (0 > t || t > d.slideCount - d.options.slidesToScroll) ? void(!1 === d.options.fade && (s = d.currentSlide, !0 !== i ? d.animateSlide(r, function() {
                    d.postSlide(s)
                }) : d.postSlide(s))) : (d.options.autoplay && clearInterval(d.autoPlayTimer), o = 0 > s ? d.slideCount % d.options.slidesToScroll != 0 ? d.slideCount - d.slideCount % d.options.slidesToScroll : d.slideCount + s : s >= d.slideCount ? d.slideCount % d.options.slidesToScroll != 0 ? 0 : s - d.slideCount : s, d.animating = !0, d.$slider.trigger("beforeChange", [d, d.currentSlide, o]), n = d.currentSlide, d.currentSlide = o, d.setSlideClasses(d.currentSlide), d.options.asNavFor && ((a = (a = d.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(d.currentSlide)), d.updateDots(), d.updateArrows(), !0 === d.options.fade ? (!0 !== i ? (d.fadeSlideOut(n), d.fadeSlide(o, function() {
                    d.postSlide(o)
                })) : d.postSlide(o), void d.animateHeight()) : void(!0 !== i ? d.animateSlide(l, function() {
                    d.postSlide(o)
                }) : d.postSlide(o))))
            }, e.prototype.startLoad = function() {
                var t = this;
                !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), t.$nextArrow.hide()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(), t.$slider.addClass("slick-loading")
            }, e.prototype.swipeDirection = function() {
                var t, e, i, s, o = this;
                return t = o.touchObject.startX - o.touchObject.curX, e = o.touchObject.startY - o.touchObject.curY, i = Math.atan2(e, t), 0 > (s = Math.round(180 * i / Math.PI)) && (s = 360 - Math.abs(s)), 45 >= s && s >= 0 ? !1 === o.options.rtl ? "left" : "right" : 360 >= s && s >= 315 ? !1 === o.options.rtl ? "left" : "right" : s >= 135 && 225 >= s ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? s >= 35 && 135 >= s ? "down" : "up" : "vertical"
            }, e.prototype.swipeEnd = function(t) {
                var e, i, s = this;
                if (s.dragging = !1, s.interrupted = !1, s.shouldClick = !(s.touchObject.swipeLength > 10), void 0 === s.touchObject.curX) return !1;
                if (!0 === s.touchObject.edgeHit && s.$slider.trigger("edge", [s, s.swipeDirection()]), s.touchObject.swipeLength >= s.touchObject.minSwipe) {
                    switch (i = s.swipeDirection()) {
                        case "left":
                        case "down":
                            e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide + s.getSlideCount()) : s.currentSlide + s.getSlideCount(), s.currentDirection = 0;
                            break;
                        case "right":
                        case "up":
                            e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide - s.getSlideCount()) : s.currentSlide - s.getSlideCount(), s.currentDirection = 1
                    }
                    "vertical" != i && (s.slideHandler(e), s.touchObject = {}, s.$slider.trigger("swipe", [s, i]))
                } else s.touchObject.startX !== s.touchObject.curX && (s.slideHandler(s.currentSlide), s.touchObject = {})
            }, e.prototype.swipeHandler = function(t) {
                var e = this;
                if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
                    case "start":
                        e.swipeStart(t);
                        break;
                    case "move":
                        e.swipeMove(t);
                        break;
                    case "end":
                        e.swipeEnd(t)
                }
            }, e.prototype.swipeMove = function(t) {
                var e, i, s, o, n, r = this;
                return n = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !(!r.dragging || n && 1 !== n.length) && (e = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== n ? n[0].pageX : t.clientX, r.touchObject.curY = void 0 !== n ? n[0].pageY : t.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), "vertical" !== (i = r.swipeDirection()) ? (void 0 !== t.originalEvent && r.touchObject.swipeLength > 4 && t.preventDefault(), o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1), s = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (s = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = e + s * o : r.swipeLeft = e + s * (r.$list.height() / r.listWidth) * o, !0 === r.options.verticalSwiping && (r.swipeLeft = e + s * o), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))) : void 0)
            }, e.prototype.swipeStart = function(t) {
                var e, i = this;
                return i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, void(i.dragging = !0))
            }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
                var t = this;
                null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.appendTo(t.$slideTrack), t.reinit())
            }, e.prototype.unload = function() {
                var e = this;
                t(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
            }, e.prototype.unslick = function(t) {
                this.$slider.trigger("unslick", [this, t]), this.destroy()
            }, e.prototype.updateArrows = function() {
                var t = this;
                Math.floor(t.options.slidesToShow / 2), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && !t.options.infinite && (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === t.currentSlide ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
            }, e.prototype.updateDots = function() {
                var t = this;
                null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
            }, e.prototype.visibility = function() {
                this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
            }, t.fn.slick = function() {
                var t, i, s = this,
                    o = arguments[0],
                    n = Array.prototype.slice.call(arguments, 1),
                    r = s.length;
                for (t = 0; r > t; t++)
                    if ("object" == typeof o || void 0 === o ? s[t].slick = new e(s[t], o) : i = s[t].slick[o].apply(s[t].slick, n), void 0 !== i) return i;
                return s
            }
        }), jQuery.cookie = function(t, e, i) {
            if (void 0 === e) {
                var s = null;
                if (document.cookie && "" != document.cookie)
                    for (var o = document.cookie.split(";"), n = 0; n < o.length; n++) {
                        var r = jQuery.trim(o[n]);
                        if (r.substring(0, t.length + 1) == t + "=") {
                            s = decodeURIComponent(r.substring(t.length + 1));
                            break
                        }
                    }
                return s
            }
            i = i || {}, null === e && (e = "", i.expires = -1);
            var a, l = "";
            i.expires && ("number" == typeof i.expires || i.expires.toUTCString) && ("number" == typeof i.expires ? (a = new Date).setTime(a.getTime() + 24 * i.expires * 60 * 60 * 1e3) : a = i.expires, l = "; expires=" + a.toUTCString());
            var d = i.path ? "; path=" + i.path : "",
                c = i.domain ? "; domain=" + i.domain : "",
                p = i.secure ? "; secure" : "";
            document.cookie = [t, "=", encodeURIComponent(e), l, d, c, p].join("")
        }, window.Modernizr = function(t, e, i) {
            function s(t) {
                h.cssText = t
            }

            function o(t, e) {
                return typeof t === e
            }

            function n(t, e) {
                for (var s in t) {
                    var o = t[s];
                    if (!~("" + o).indexOf("-") && h[o] !== i) return "pfx" != e || o
                }
                return !1
            }

            function r(t, e, s) {
                var r = t.charAt(0).toUpperCase() + t.slice(1),
                    a = (t + " " + g.join(r + " ") + r).split(" ");
                return o(e, "string") || o(e, "undefined") ? n(a, e) : function(t, e, s) {
                    for (var n in t) {
                        var r = e[t[n]];
                        if (r !== i) return !1 === s ? t[n] : o(r, "function") ? r.bind(s || e) : r
                    }
                    return !1
                }(a = (t + " " + v.join(r + " ") + r).split(" "), e, s)
            }
            var a, l, d = {},
                c = e.documentElement,
                p = e.createElement("modernizr"),
                h = p.style,
                u = e.createElement("input"),
                f = "Webkit Moz O ms",
                g = f.split(" "),
                v = f.toLowerCase().split(" "),
                m = {},
                y = {},
                w = [],
                b = w.slice,
                S = {}.hasOwnProperty;
            l = o(S, "undefined") || o(S.call, "undefined") ? function(t, e) {
                return e in t && o(t.constructor.prototype[e], "undefined")
            } : function(t, e) {
                return S.call(t, e)
            }, Function.prototype.bind || (Function.prototype.bind = function(t) {
                var e = this;
                if ("function" != typeof e) throw new TypeError;
                var i = b.call(arguments, 1),
                    s = function() {
                        if (this instanceof s) {
                            var o = function() {};
                            o.prototype = e.prototype;
                            var n = new o,
                                r = e.apply(n, i.concat(b.call(arguments)));
                            return Object(r) === r ? r : n
                        }
                        return e.apply(t, i.concat(b.call(arguments)))
                    };
                return s
            }), m.csstransitions = function() {
                return r("transition")
            };
            for (var k in m) l(m, k) && (a = k.toLowerCase(), d[a] = m[k](), w.push((d[a] ? "" : "no-") + a));
            return d.input || (d.input = function(i) {
                for (var s = 0, o = i.length; s < o; s++) y[i[s]] = i[s] in u;
                return y.list && (y.list = !!e.createElement("datalist") && !!t.HTMLDataListElement), y
            }("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))), d.addTest = function(t, e) {
                if ("object" == typeof t)
                    for (var s in t) l(t, s) && d.addTest(s, t[s]);
                else {
                    if (t = t.toLowerCase(), d[t] !== i) return d;
                    e = "function" == typeof e ? e() : e, "undefined" != typeof enableClasses && enableClasses && (c.className += " " + (e ? "" : "no-") + t), d[t] = e
                }
                return d
            }, s(""), p = u = null, d._version = "2.6.2", d._domPrefixes = v, d._cssomPrefixes = g, d.testProp = function(t) {
                return n([t])
            }, d.testAllProps = r, d
        }(this, this.document),
        function(t, e, i) {
            function s(t) {
                return "[object Function]" == g.call(t)
            }

            function o(t) {
                return "string" == typeof t
            }

            function n() {}

            function r(t) {
                return !t || "loaded" == t || "complete" == t || "uninitialized" == t
            }

            function a() {
                var t = v.shift();
                m = 1, t ? t.t ? u(function() {
                    ("c" == t.t ? p.injectCss : p.injectJs)(t.s, 0, t.a, t.x, t.e, 1)
                }, 0) : (t(), a()) : m = 0
            }

            function l(t, i, s, n, l) {
                return m = 0, i = i || "j", o(t) ? function(t, i, s, o, n, l, d) {
                    function c(e) {
                        if (!g && r(h.readyState) && (S.r = g = 1, !m && a(), h.onload = h.onreadystatechange = null, e)) {
                            "img" != t && u(function() {
                                b.removeChild(h)
                            }, 50);
                            for (var s in T[i]) T[i].hasOwnProperty(s) && T[i][s].onload()
                        }
                    }
                    d = d || p.errorTimeout;
                    var h = e.createElement(t),
                        g = 0,
                        y = 0,
                        S = {
                            t: s,
                            s: i,
                            e: n,
                            a: l,
                            x: d
                        };
                    1 === T[i] && (y = 1, T[i] = []), "object" == t ? h.data = i : (h.src = i, h.type = t), h.width = h.height = "0", h.onerror = h.onload = h.onreadystatechange = function() {
                        c.call(this, y)
                    }, v.splice(o, 0, S), "img" != t && (y || 2 === T[i] ? (b.insertBefore(h, w ? null : f), u(c, d)) : T[i].push(h))
                }("c" == i ? k : S, t, i, this.i++, s, n, l) : (v.splice(this.i++, 0, t), 1 == v.length && a()), this
            }

            function d() {
                var t = p;
                return t.loader = {
                    load: l,
                    i: 0
                }, t
            }
            var c, p, h = e.documentElement,
                u = t.setTimeout,
                f = e.getElementsByTagName("script")[0],
                g = {}.toString,
                v = [],
                m = 0,
                y = "MozAppearance" in h.style,
                w = y && !!e.createRange().compareNode,
                b = w ? h : f.parentNode,
                S = (h = t.opera && "[object Opera]" == g.call(t.opera), h = !!e.attachEvent && !h, y ? "object" : h ? "script" : "img"),
                k = h ? "script" : S,
                C = Array.isArray || function(t) {
                    return "[object Array]" == g.call(t)
                },
                _ = [],
                T = {},
                $ = {
                    timeout: function(t, e) {
                        return e.length && (t.timeout = e[0]), t
                    }
                };
            (p = function(t) {
                function e(t, e, o, n, r) {
                    var a = function(t) {
                            t = t.split("!");
                            var e, i, s, o = _.length,
                                n = t.pop(),
                                r = t.length;
                            for (n = {
                                    url: n,
                                    origUrl: n,
                                    prefixes: t
                                }, i = 0; i < r; i++) s = t[i].split("="), (e = $[s.shift()]) && (n = e(n, s));
                            for (i = 0; i < o; i++) n = _[i](n);
                            return n
                        }(t),
                        l = a.autoCallback;
                    a.url.split(".").pop().split("?").shift(), a.bypass || (e && (e = s(e) ? e : e[t] || e[n] || e[t.split("/").pop().split("?")[0]]), a.instead ? a.instead(t, e, o, n, r) : (T[a.url] ? a.noexec = !0 : T[a.url] = 1, o.load(a.url, a.forceCSS || !a.forceJS && "css" == a.url.split(".").pop().split("?").shift() ? "c" : i, a.noexec, a.attrs, a.timeout), (s(e) || s(l)) && o.load(function() {
                        d(), e && e(a.origUrl, r, n), l && l(a.origUrl, r, n), T[a.url] = 2
                    })))
                }

                function r(t, i) {
                    function r(t, n) {
                        if (t) {
                            if (o(t)) n || (p = function() {
                                var t = [].slice.call(arguments);
                                h.apply(this, t), u()
                            }), e(t, p, i, 0, d);
                            else if (Object(t) === t)
                                for (l in a = function() {
                                        var e, i = 0;
                                        for (e in t) t.hasOwnProperty(e) && i++;
                                        return i
                                    }(), t) t.hasOwnProperty(l) && (!n && !--a && (s(p) ? p = function() {
                                    var t = [].slice.call(arguments);
                                    h.apply(this, t), u()
                                } : p[l] = function(t) {
                                    return function() {
                                        var e = [].slice.call(arguments);
                                        t && t.apply(this, e), u()
                                    }
                                }(h[l])), e(t[l], p, i, l, d))
                        } else !n && u()
                    }
                    var a, l, d = !!t.test,
                        c = t.load || t.both,
                        p = t.callback || n,
                        h = p,
                        u = t.complete || n;
                    r(d ? t.yep : t.nope, !!c), c && r(c)
                }
                var a, l, c = this.yepnope.loader;
                if (o(t)) e(t, 0, c, 0);
                else if (C(t))
                    for (a = 0; a < t.length; a++) l = t[a], o(l) ? e(l, 0, c, 0) : C(l) ? p(l) : Object(l) === l && r(l, c);
                else Object(t) === t && r(t, c)
            }).addPrefix = function(t, e) {
                $[t] = e
            }, p.addFilter = function(t) {
                _.push(t)
            }, p.errorTimeout = 1e4, null == e.readyState && e.addEventListener && (e.readyState = "loading", e.addEventListener("DOMContentLoaded", c = function() {
                e.removeEventListener("DOMContentLoaded", c, 0), e.readyState = "complete"
            }, 0)), t.yepnope = d(), t.yepnope.executeStack = a, t.yepnope.injectJs = function(t, i, s, o, l, d) {
                var c, h, g = e.createElement("script");
                o = o || p.errorTimeout;
                g.src = t;
                for (h in s) g.setAttribute(h, s[h]);
                i = d ? a : i || n, g.onreadystatechange = g.onload = function() {
                    !c && r(g.readyState) && (c = 1, i(), g.onload = g.onreadystatechange = null)
                }, u(function() {
                    c || (c = 1, i(1))
                }, o), l ? g.onload() : f.parentNode.insertBefore(g, f)
            }, t.yepnope.injectCss = function(t, i, s, o, r, l) {
                var d;
                o = e.createElement("link"), i = l ? a : i || n;
                o.href = t, o.rel = "stylesheet", o.type = "text/css";
                for (d in s) o.setAttribute(d, s[d]);
                r || (f.parentNode.insertBefore(o, f), u(i, 0))
            }
        }(this, document), Modernizr.load = function() {
            yepnope.apply(window, [].slice.call(arguments, 0))
        },
        function(t) {
            "use strict";

            function e() {}

            function i() {
                try {
                    return document.activeElement
                } catch (t) {}
            }

            function s(t, e) {
                for (var i = 0, s = t.length; s > i; i++)
                    if (t[i] === e) return !0;
                return !1
            }

            function o(t, e, i) {
                return t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent ? t.attachEvent("on" + e, i) : void 0
            }

            function n(t, e) {
                var i;
                t.createTextRange ? ((i = t.createTextRange()).move("character", e), i.select()) : t.selectionStart && (t.focus(), t.setSelectionRange(e, e))
            }

            function r(t, e) {
                try {
                    return t.type = e, !0
                } catch (t) {
                    return !1
                }
            }

            function a(t, e) {
                if (t && t.getAttribute(y)) e(t);
                else
                    for (var i, s = t ? t.getElementsByTagName("input") : z, o = t ? t.getElementsByTagName("textarea") : x, n = s ? s.length : 0, r = o ? o.length : 0, a = n + r, l = 0; a > l; l++) i = n > l ? s[l] : o[l - n], e(i)
            }

            function l(t) {
                a(t, d)
            }

            function d(t, e) {
                var i = !!e && t.value !== e,
                    s = t.value === t.getAttribute(y);
                if ((i || s) && "true" === t.getAttribute(w)) {
                    t.removeAttribute(w), t.value = t.value.replace(t.getAttribute(y), ""), t.className = t.className.replace(m, "");
                    var o = t.getAttribute(C);
                    parseInt(o, 10) >= 0 && (t.setAttribute("maxLength", o), t.removeAttribute(C));
                    var n = t.getAttribute(b);
                    return n && (t.type = n), !0
                }
                return !1
            }

            function c(t) {
                var e = t.getAttribute(y);
                return !("" !== t.value || !e) && (t.setAttribute(w, "true"), t.value = e, t.className += " " + v, t.getAttribute(C) || (t.setAttribute(C, t.maxLength), t.removeAttribute("maxLength")), t.getAttribute(b) ? t.type = "text" : "password" === t.type && r(t, "text") && t.setAttribute(b, "password"), !0)
            }

            function p(t) {
                var e, r, a, p, h, f, v = t.form;
                v && "string" == typeof v && ((v = document.getElementById(v)).getAttribute(S) || (o(v, "submit", (f = v, function() {
                    l(f)
                })), v.setAttribute(S, "true"))), o(t, "focus", (h = t, function() {
                    A && h.value === h.getAttribute(y) && "true" === h.getAttribute(w) ? n(h, 0) : d(h)
                })), o(t, "blur", (p = t, function() {
                    c(p)
                })), A && (o(t, "keydown", (a = t, function(t) {
                    return u = a.value, "true" === a.getAttribute(w) && u === a.getAttribute(y) && s(g, t.keyCode) ? (t.preventDefault && t.preventDefault(), !1) : void 0
                })), o(t, "keyup", (r = t, function() {
                    d(r, u), "" === r.value && (r.blur(), n(r, 0))
                })), o(t, "click", (e = t, function() {
                    e === i() && e.value === e.getAttribute(y) && "true" === e.getAttribute(w) && n(e, 0)
                }))), t.setAttribute(k, "true"), t.setAttribute(y, L), (A || t !== i()) && c(t)
            }
            var h = void 0 !== document.createElement("input").placeholder;
            if (t.Placeholders = {
                    nativeSupport: h,
                    disable: h ? e : l,
                    enable: h ? e : function(t) {
                        a(t, c)
                    }
                }, !h) {
                var u, f = ["text", "search", "url", "tel", "email", "password", "number", "textarea"],
                    g = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46],
                    v = "placeholdersjs",
                    m = new RegExp("(?:^|\\s)" + v + "(?!\\S)"),
                    y = "data-placeholder-value",
                    w = "data-placeholder-active",
                    b = "data-placeholder-type",
                    S = "data-placeholder-submit",
                    k = "data-placeholder-bound",
                    C = "data-placeholder-maxlength",
                    _ = document.getElementsByTagName("head")[0],
                    T = document.documentElement,
                    $ = t.Placeholders,
                    z = document.getElementsByTagName("input"),
                    x = document.getElementsByTagName("textarea"),
                    A = "false" === T.getAttribute("data-placeholder-focus"),
                    E = "false" !== T.getAttribute("data-placeholder-live"),
                    P = document.createElement("style");
                P.type = "text/css";
                var M = document.createTextNode("." + v + " {color:#ccc;}");
                P.styleSheet ? P.styleSheet.cssText = M.nodeValue : P.appendChild(M), _.insertBefore(P, _.firstChild);
                for (var L, O, D = 0, j = z.length + x.length; j > D; D++) O = D < z.length ? z[D] : x[D - z.length], L = O.attributes.placeholder, L && (L = L.nodeValue, L && s(f, O.type) && p(O));
                var N = setInterval(function() {
                    for (var t = 0, e = z.length + x.length; e > t; t++) O = t < z.length ? z[t] : x[t - z.length], L = O.attributes.placeholder, L ? (L = L.nodeValue, L && s(f, O.type) && (O.getAttribute(k) || p(O), (L !== O.getAttribute(y) || "password" === O.type && !O.getAttribute(b)) && ("password" === O.type && !O.getAttribute(b) && r(O, "text") && O.setAttribute(b, "password"), O.value === O.getAttribute(y) && (O.value = L), O.setAttribute(y, L)))) : O.getAttribute(w) && (d(O), O.removeAttribute(y));
                    E || clearInterval(N)
                }, 100);
                o(t, "beforeunload", function() {
                    $.disable()
                })
            }
        }(this),
        function(t, e) {
            "use strict";
            var i = t.fn.val,
                s = t.fn.prop;
            e.Placeholders.nativeSupport || (t.fn.val = function(t) {
                var e = i.apply(this, arguments),
                    s = this.eq(0).data("placeholder-value");
                return void 0 === t && this.eq(0).data("placeholder-active") && e === s ? "" : e
            }, t.fn.prop = function(t, e) {
                return void 0 === e && this.eq(0).data("placeholder-active") && "value" === t ? "" : s.apply(this, arguments)
            })
        }(jQuery, this), y = jQuery, S = y.event, w = S.special.debouncedresize = {
            setup: function() {
                y(this).on("resize", w.handler)
            },
            teardown: function() {
                y(this).off("resize", w.handler)
            },
            handler: function(t, e) {
                var i = this,
                    s = arguments,
                    o = function() {
                        t.type = "debouncedresize", S.dispatch.apply(i, s)
                    };
                b && clearTimeout(b), e ? o() : b = setTimeout(o, w.threshold)
            },
            threshold: 200
        },
        function(t, e, i, s) {
            function o(e, i) {
                this.settings = null, this.options = t.extend({}, o.Defaults, i), this.$element = t(e), this.drag = t.extend({}, a), this.state = t.extend({}, l), this.e = t.extend({}, d), this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._invalidated = {}, this._pipe = [], t.each(o.Plugins, t.proxy(function(t, e) {
                    this._plugins[t[0].toLowerCase() + t.slice(1)] = new e(this)
                }, this)), t.each(o.Pipe, t.proxy(function(e, i) {
                    this._pipe.push({
                        filter: i.filter,
                        run: t.proxy(i.run, this)
                    })
                }, this)), this.setup(), this.initialize()
            }

            function n(t) {
                if (t.touches !== s) return {
                    x: t.touches[0].pageX,
                    y: t.touches[0].pageY
                };
                if (t.touches === s) {
                    if (t.pageX !== s) return {
                        x: t.pageX,
                        y: t.pageY
                    };
                    if (t.pageX === s) return {
                        x: t.clientX,
                        y: t.clientY
                    }
                }
            }

            function r(t) {
                var e, s, o = i.createElement("div"),
                    n = t;
                for (e in n)
                    if (s = n[e], void 0 !== o.style[s]) return o = null, [s, e];
                return [!1]
            }
            var a, l, d;
            a = {
                start: 0,
                startX: 0,
                startY: 0,
                current: 0,
                currentX: 0,
                currentY: 0,
                offsetX: 0,
                offsetY: 0,
                distance: null,
                startTime: 0,
                endTime: 0,
                updatedX: 0,
                targetEl: null
            }, l = {
                isTouch: !1,
                isScrolling: !1,
                isSwiping: !1,
                direction: !1,
                inMotion: !1
            }, d = {
                _onDragStart: null,
                _onDragMove: null,
                _onDragEnd: null,
                _transitionEnd: null,
                _resizer: null,
                _responsiveCall: null,
                _goToLoop: null,
                _checkVisibile: null
            }, o.Defaults = {
                items: 3,
                loop: !1,
                center: !1,
                mouseDrag: !0,
                touchDrag: !0,
                pullDrag: !0,
                freeDrag: !1,
                margin: 0,
                stagePadding: 0,
                merge: !1,
                mergeFit: !0,
                autoWidth: !1,
                startPosition: 0,
                rtl: !1,
                smartSpeed: 250,
                fluidSpeed: !1,
                dragEndSpeed: !1,
                responsive: {},
                responsiveRefreshRate: 200,
                responsiveBaseElement: e,
                responsiveClass: !1,
                fallbackEasing: "swing",
                info: !1,
                nestedItemSelector: !1,
                itemElement: "div",
                stageElement: "div",
                themeClass: "owl-theme",
                baseClass: "owl-carousel",
                itemClass: "owl-item",
                centerClass: "center",
                activeClass: "active"
            }, o.Width = {
                Default: "default",
                Inner: "inner",
                Outer: "outer"
            }, o.Plugins = {}, o.Pipe = [{
                filter: ["width", "items", "settings"],
                run: function(t) {
                    t.current = this._items && this._items[this.relative(this._current)]
                }
            }, {
                filter: ["items", "settings"],
                run: function() {
                    var t = this._clones;
                    (this.$stage.children(".cloned").length !== t.length || !this.settings.loop && t.length > 0) && (this.$stage.children(".cloned").remove(), this._clones = [])
                }
            }, {
                filter: ["items", "settings"],
                run: function() {
                    var t, e, i = this._clones,
                        s = this._items,
                        o = this.settings.loop ? i.length - Math.max(2 * this.settings.items, 4) : 0;
                    for (t = 0, e = Math.abs(o / 2); e > t; t++) o > 0 ? (this.$stage.children().eq(s.length + i.length - 1).remove(), i.pop(), this.$stage.children().eq(0).remove(), i.pop()) : (i.push(i.length / 2), this.$stage.append(s[i[i.length - 1]].clone().addClass("cloned")), i.push(s.length - 1 - (i.length - 1) / 2), this.$stage.prepend(s[i[i.length - 1]].clone().addClass("cloned")))
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function() {
                    var t, e, i, s = this.settings.rtl ? 1 : -1,
                        o = (this.width() / this.settings.items).toFixed(3),
                        n = 0;
                    for (this._coordinates = [], e = 0, i = this._clones.length + this._items.length; i > e; e++) t = this._mergers[this.relative(e)], t = this.settings.mergeFit && Math.min(t, this.settings.items) || t, n += (this.settings.autoWidth ? this._items[this.relative(e)].width() + this.settings.margin : o * t) * s, this._coordinates.push(n)
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function() {
                    var e, i, s = (this.width() / this.settings.items).toFixed(3),
                        o = {
                            width: Math.abs(this._coordinates[this._coordinates.length - 1]) + 2 * this.settings.stagePadding,
                            "padding-left": this.settings.stagePadding || "",
                            "padding-right": this.settings.stagePadding || ""
                        };
                    if (this.$stage.css(o), (o = {
                            width: this.settings.autoWidth ? "auto" : s - this.settings.margin
                        })[this.settings.rtl ? "margin-left" : "margin-right"] = this.settings.margin, !this.settings.autoWidth && t.grep(this._mergers, function(t) {
                            return t > 1
                        }).length > 0)
                        for (e = 0, i = this._coordinates.length; i > e; e++) o.width = Math.abs(this._coordinates[e]) - Math.abs(this._coordinates[e - 1] || 0) - this.settings.margin, this.$stage.children().eq(e).css(o);
                    else this.$stage.children().css(o)
                }
            }, {
                filter: ["width", "items", "settings"],
                run: function(t) {
                    t.current && this.reset(this.$stage.children().index(t.current))
                }
            }, {
                filter: ["position"],
                run: function() {
                    this.animate(this.coordinates(this._current))
                }
            }, {
                filter: ["width", "position", "items", "settings"],
                run: function() {
                    var t, e, i, s, o = this.settings.rtl ? 1 : -1,
                        n = 2 * this.settings.stagePadding,
                        r = this.coordinates(this.current()) + n,
                        a = r + this.width() * o,
                        l = [];
                    for (i = 0, s = this._coordinates.length; s > i; i++) t = this._coordinates[i - 1] || 0, e = Math.abs(this._coordinates[i]) + n * o, (this.op(t, "<=", r) && this.op(t, ">", a) || this.op(e, "<", r) && this.op(e, ">", a)) && l.push(i);
                    this.$stage.children("." + this.settings.activeClass).removeClass(this.settings.activeClass), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass(this.settings.activeClass), this.settings.center && (this.$stage.children("." + this.settings.centerClass).removeClass(this.settings.centerClass), this.$stage.children().eq(this.current()).addClass(this.settings.centerClass))
                }
            }], o.prototype.initialize = function() {
                var e, i, o;
                if ((this.trigger("initialize"), this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass("owl-rtl", this.settings.rtl), this.browserSupport(), this.settings.autoWidth && !0 !== this.state.imagesLoaded) && (e = this.$element.find("img"), i = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : s, o = this.$element.children(i).width(), e.length && 0 >= o)) return this.preloadAutoWidthImages(e), !1;
                this.$element.addClass("owl-loading"), this.$stage = t("<" + this.settings.stageElement + ' class="owl-stage"/>').wrap('<div class="owl-stage-outer">'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this._width = this.$element.width(), this.refresh(), this.$element.removeClass("owl-loading").addClass("owl-loaded"), this.eventsCall(), this.internalEvents(), this.addTriggerableEvents(), this.trigger("initialized")
            }, o.prototype.setup = function() {
                var e = this.viewport(),
                    i = this.options.responsive,
                    s = -1,
                    o = null;
                i ? (t.each(i, function(t) {
                    e >= t && t > s && (s = Number(t))
                }), delete(o = t.extend({}, this.options, i[s])).responsive, o.responsiveClass && this.$element.attr("class", function(t, e) {
                    return e.replace(/\b owl-responsive-\S+/g, "")
                }).addClass("owl-responsive-" + s)) : o = t.extend({}, this.options), (null === this.settings || this._breakpoint !== s) && (this.trigger("change", {
                    property: {
                        name: "settings",
                        value: o
                    }
                }), this._breakpoint = s, this.settings = o, this.invalidate("settings"), this.trigger("changed", {
                    property: {
                        name: "settings",
                        value: this.settings
                    }
                }))
            }, o.prototype.optionsLogic = function() {
                this.$element.toggleClass("owl-center", this.settings.center), this.settings.loop && this._items.length < this.settings.items && (this.settings.loop = !1), this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
            }, o.prototype.prepare = function(e) {
                var i = this.trigger("prepare", {
                    content: e
                });
                return i.data || (i.data = t("<" + this.settings.itemElement + "/>").addClass(this.settings.itemClass).append(e)), this.trigger("prepared", {
                    content: i.data
                }), i.data
            }, o.prototype.update = function() {
                for (var e = 0, i = this._pipe.length, s = t.proxy(function(t) {
                        return this[t]
                    }, this._invalidated), o = {}; i > e;)(this._invalidated.all || t.grep(this._pipe[e].filter, s).length > 0) && this._pipe[e].run(o), e++;
                this._invalidated = {}
            }, o.prototype.width = function(t) {
                switch (t = t || o.Width.Default) {
                    case o.Width.Inner:
                    case o.Width.Outer:
                        return this._width;
                    default:
                        return this._width - 2 * this.settings.stagePadding + this.settings.margin
                }
            }, o.prototype.refresh = function() {
                if (0 === this._items.length) return !1;
                (new Date).getTime(), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$stage.addClass("owl-refresh"), this.update(), this.$stage.removeClass("owl-refresh"), this.state.orientation = e.orientation, this.watchVisibility(), this.trigger("refreshed")
            }, o.prototype.eventsCall = function() {
                this.e._onDragStart = t.proxy(function(t) {
                    this.onDragStart(t)
                }, this), this.e._onDragMove = t.proxy(function(t) {
                    this.onDragMove(t)
                }, this), this.e._onDragEnd = t.proxy(function(t) {
                    this.onDragEnd(t)
                }, this), this.e._onResize = t.proxy(function(t) {
                    this.onResize(t)
                }, this), this.e._transitionEnd = t.proxy(function(t) {
                    this.transitionEnd(t)
                }, this), this.e._preventClick = t.proxy(function(t) {
                    this.preventClick(t)
                }, this)
            }, o.prototype.onThrottledResize = function() {
                e.clearTimeout(this.resizeTimer), this.resizeTimer = e.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate)
            }, o.prototype.onResize = function() {
                return !!this._items.length && (this._width !== this.$element.width() && (!this.trigger("resize").isDefaultPrevented() && (this._width = this.$element.width(), this.invalidate("width"), this.refresh(), void this.trigger("resized"))))
            }, o.prototype.eventsRouter = function(t) {
                var e = t.type;
                "mousedown" === e || "touchstart" === e ? this.onDragStart(t) : "mousemove" === e || "touchmove" === e ? this.onDragMove(t) : "mouseup" === e || "touchend" === e ? this.onDragEnd(t) : "touchcancel" === e && this.onDragEnd(t)
            }, o.prototype.internalEvents = function() {
                var i = ("ontouchstart" in e || navigator.msMaxTouchPoints, e.navigator.msPointerEnabled);
                this.settings.mouseDrag ? (this.$stage.on("mousedown", t.proxy(function(t) {
                    this.eventsRouter(t)
                }, this)), this.$stage.on("dragstart", function() {
                    return !1
                }), this.$stage.get(0).onselectstart = function() {
                    return !1
                }) : this.$element.addClass("owl-text-select-on"), this.settings.touchDrag && !i && this.$stage.on("touchstart touchcancel", t.proxy(function(t) {
                    this.eventsRouter(t)
                }, this)), this.transitionEndVendor && this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, !1), !1 !== this.settings.responsive && this.on(e, "resize", t.proxy(this.onThrottledResize, this))
            }, o.prototype.onDragStart = function(s) {
                var o, r, a, l;
                if (3 === (o = s.originalEvent || s || e.event).which || this.state.isTouch) return !1;
                if ("mousedown" === o.type && this.$stage.addClass("owl-grab"), this.trigger("drag"), this.drag.startTime = (new Date).getTime(), this.speed(0), this.state.isTouch = !0, this.state.isScrolling = !1, this.state.isSwiping = !1, this.drag.distance = 0, r = n(o).x, a = n(o).y, this.drag.offsetX = this.$stage.position().left, this.drag.offsetY = this.$stage.position().top, this.settings.rtl && (this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width() + this.settings.margin), this.state.inMotion && this.support3d) l = this.getTransformProperty(), this.drag.offsetX = l, this.animate(l), this.state.inMotion = !0;
                else if (this.state.inMotion && !this.support3d) return this.state.inMotion = !1, !1;
                this.drag.startX = r - this.drag.offsetX, this.drag.startY = a - this.drag.offsetY, this.drag.start = r - this.drag.startX, this.drag.targetEl = o.target || o.srcElement, this.drag.updatedX = this.drag.start, ("IMG" === this.drag.targetEl.tagName || "A" === this.drag.targetEl.tagName) && (this.drag.targetEl.draggable = !1), t(i).on("mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents", t.proxy(function(t) {
                    this.eventsRouter(t)
                }, this))
            }, o.prototype.onDragMove = function(t) {
                var i, o, r, a, l, d;
                this.state.isTouch && (this.state.isScrolling || (o = n(i = t.originalEvent || t || e.event).x, r = n(i).y, this.drag.currentX = o - this.drag.startX, this.drag.currentY = r - this.drag.startY, this.drag.distance = this.drag.currentX - this.drag.offsetX, this.drag.distance < 0 ? this.state.direction = this.settings.rtl ? "right" : "left" : this.drag.distance > 0 && (this.state.direction = this.settings.rtl ? "left" : "right"), this.settings.loop ? this.op(this.drag.currentX, ">", this.coordinates(this.minimum())) && "right" === this.state.direction ? this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length) : this.op(this.drag.currentX, "<", this.coordinates(this.maximum())) && "left" === this.state.direction && (this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length)) : (a = this.coordinates(this.settings.rtl ? this.maximum() : this.minimum()), l = this.coordinates(this.settings.rtl ? this.minimum() : this.maximum()), d = this.settings.pullDrag ? this.drag.distance / 5 : 0, this.drag.currentX = Math.max(Math.min(this.drag.currentX, a + d), l + d)), (this.drag.distance > 8 || this.drag.distance < -8) && (i.preventDefault !== s ? i.preventDefault() : i.returnValue = !1, this.state.isSwiping = !0), this.drag.updatedX = this.drag.currentX, (this.drag.currentY > 16 || this.drag.currentY < -16) && !1 === this.state.isSwiping && (this.state.isScrolling = !0, this.drag.updatedX = this.drag.start), this.animate(this.drag.updatedX)))
            }, o.prototype.onDragEnd = function(e) {
                var s, o;
                if (this.state.isTouch) {
                    if ("mouseup" === e.type && this.$stage.removeClass("owl-grab"), this.trigger("dragged"), this.drag.targetEl.removeAttribute("draggable"), this.state.isTouch = !1, this.state.isScrolling = !1, this.state.isSwiping = !1, 0 === this.drag.distance && !0 !== this.state.inMotion) return this.state.inMotion = !1, !1;
                    this.drag.endTime = (new Date).getTime(), s = this.drag.endTime - this.drag.startTime, (Math.abs(this.drag.distance) > 3 || s > 300) && this.removeClick(this.drag.targetEl), o = this.closest(this.drag.updatedX), this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(o), this.invalidate("position"), this.update(), this.settings.pullDrag || this.drag.updatedX !== this.coordinates(o) || this.transitionEnd(), this.drag.distance = 0, t(i).off(".owl.dragEvents")
                }
            }, o.prototype.removeClick = function(i) {
                this.drag.targetEl = i, t(i).on("click.preventClick", this.e._preventClick), e.setTimeout(function() {
                    t(i).off("click.preventClick")
                }, 300)
            }, o.prototype.preventClick = function(e) {
                e.preventDefault ? e.preventDefault() : e.returnValue = !1, e.stopPropagation && e.stopPropagation(), t(e.target).off("click.preventClick")
            }, o.prototype.getTransformProperty = function() {
                var t;
                return !0 !== (16 === (t = (t = e.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + "transform")).replace(/matrix(3d)?\(|\)/g, "").split(",")).length) ? t[4] : t[12]
            }, o.prototype.closest = function(e) {
                var i = -1,
                    s = this.width(),
                    o = this.coordinates();
                return this.settings.freeDrag || t.each(o, t.proxy(function(t, n) {
                    return e > n - 30 && n + 30 > e ? i = t : this.op(e, "<", n) && this.op(e, ">", o[t + 1] || n - s) && (i = "left" === this.state.direction ? t + 1 : t), -1 === i
                }, this)), this.settings.loop || (this.op(e, ">", o[this.minimum()]) ? i = e = this.minimum() : this.op(e, "<", o[this.maximum()]) && (i = e = this.maximum())), i
            }, o.prototype.animate = function(e) {
                this.trigger("translating"), this.state.inMotion = this.speed() > 0, this.support3d ? this.$stage.css({
                    transform: "translate3d(" + Math.round(e) + "px,0px, 0px)",
                    transition: this.speed() / 1e3 + "s"
                }) : this.state.isTouch ? this.$stage.css({
                    left: e + "px"
                }) : this.$stage.animate({
                    left: e
                }, this.speed() / 1e3, this.settings.fallbackEasing, t.proxy(function() {
                    this.state.inMotion && this.transitionEnd()
                }, this))
            }, o.prototype.current = function(t) {
                if (t === s) return this._current;
                if (0 === this._items.length) return s;
                if (t = this.normalize(t), this._current !== t) {
                    var e = this.trigger("change", {
                        property: {
                            name: "position",
                            value: t
                        }
                    });
                    e.data !== s && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
                        property: {
                            name: "position",
                            value: this._current
                        }
                    })
                }
                return this._current
            }, o.prototype.invalidate = function(t) {
                this._invalidated[t] = !0
            }, o.prototype.reset = function(t) {
                (t = this.normalize(t)) !== s && (this._speed = 0, this._current = t, this.suppress(["translating", "translated"]), this.animate(this.coordinates(t)), this.release(["translating", "translated"]))
            }, o.prototype.normalize = function(e, i) {
                var o = i ? this._items.length : this._items.length + this._clones.length;
                return !t.isNumeric(e) || 1 > o ? s : e = this._clones.length ? (e % o + o) % o : Math.max(this.minimum(i), Math.min(this.maximum(i), e))
            }, o.prototype.relative = function(t) {
                return t = this.normalize(t), t -= this._clones.length / 2, this.normalize(t, !0)
            }, o.prototype.maximum = function(t) {
                var e, i, s, o = 0,
                    n = this.settings;
                if (t) return this._items.length - 1;
                if (!n.loop && n.center) e = this._items.length - 1;
                else if (n.loop || n.center)
                    if (n.loop || n.center) e = this._items.length + n.items;
                    else {
                        if (!n.autoWidth && !n.merge) throw "Can not detect maximum absolute position.";
                        for (revert = n.rtl ? 1 : -1, i = this.$stage.width() - this.$element.width();
                            (s = this.coordinates(o)) && !(s * revert >= i);) e = ++o
                    }
                else e = this._items.length - n.items;
                return e
            }, o.prototype.minimum = function(t) {
                return t ? 0 : this._clones.length / 2
            }, o.prototype.items = function(t) {
                return t === s ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
            }, o.prototype.mergers = function(t) {
                return t === s ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
            }, o.prototype.clones = function(e) {
                var i = this._clones.length / 2,
                    o = i + this._items.length,
                    n = function(t) {
                        return t % 2 == 0 ? o + t / 2 : i - (t + 1) / 2
                    };
                return e === s ? t.map(this._clones, function(t, e) {
                    return n(e)
                }) : t.map(this._clones, function(t, i) {
                    return t === e ? n(i) : null
                })
            }, o.prototype.speed = function(t) {
                return t !== s && (this._speed = t), this._speed
            }, o.prototype.coordinates = function(e) {
                var i = null;
                return e === s ? t.map(this._coordinates, t.proxy(function(t, e) {
                    return this.coordinates(e)
                }, this)) : (this.settings.center ? (i = this._coordinates[e], i += (this.width() - i + (this._coordinates[e - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1)) : i = this._coordinates[e - 1] || 0, i)
            }, o.prototype.duration = function(t, e, i) {
                return Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(i || this.settings.smartSpeed)
            }, o.prototype.to = function(i, s) {
                if (this.settings.loop) {
                    var o = i - this.relative(this.current()),
                        n = this.current(),
                        r = this.current(),
                        a = this.current() + o,
                        l = 0 > r - a,
                        d = this._clones.length + this._items.length;
                    a < this.settings.items && !1 === l ? (n = r + this._items.length, this.reset(n)) : a >= d - this.settings.items && !0 === l && (n = r - this._items.length, this.reset(n)), e.clearTimeout(this.e._goToLoop), this.e._goToLoop = e.setTimeout(t.proxy(function() {
                        this.speed(this.duration(this.current(), n + o, s)), this.current(n + o), this.update()
                    }, this), 30)
                } else this.speed(this.duration(this.current(), i, s)), this.current(i), this.update()
            }, o.prototype.next = function(t) {
                t = t || !1, this.to(this.relative(this.current()) + 1, t)
            }, o.prototype.prev = function(t) {
                t = t || !1, this.to(this.relative(this.current()) - 1, t)
            }, o.prototype.transitionEnd = function(t) {
                return (t === s || (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) === this.$stage.get(0))) && (this.state.inMotion = !1, void this.trigger("translated"))
            }, o.prototype.viewport = function() {
                var s;
                if (this.options.responsiveBaseElement !== e) s = t(this.options.responsiveBaseElement).width();
                else if (e.innerWidth) s = e.innerWidth;
                else {
                    if (!i.documentElement || !i.documentElement.clientWidth) throw "Can not detect viewport width.";
                    s = i.documentElement.clientWidth
                }
                return s
            }, o.prototype.replace = function(e) {
                this.$stage.empty(), this._items = [], e && (e = e instanceof jQuery ? e : t(e)), this.settings.nestedItemSelector && (e = e.find("." + this.settings.nestedItemSelector)), e.filter(function() {
                    return 1 === this.nodeType
                }).each(t.proxy(function(t, e) {
                    e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)
                }, this)), this.reset(t.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
            }, o.prototype.add = function(t, e) {
                e = e === s ? this._items.length : this.normalize(e, !0), this.trigger("add", {
                    content: t,
                    position: e
                }), 0 === this._items.length || e === this._items.length ? (this.$stage.append(t), this._items.push(t), this._mergers.push(1 * t.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)) : (this._items[e].before(t), this._items.splice(e, 0, t), this._mergers.splice(e, 0, 1 * t.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)), this.invalidate("items"), this.trigger("added", {
                    content: t,
                    position: e
                })
            }, o.prototype.remove = function(t) {
                (t = this.normalize(t, !0)) !== s && (this.trigger("remove", {
                    content: this._items[t],
                    position: t
                }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
                    content: null,
                    position: t
                }))
            }, o.prototype.addTriggerableEvents = function() {
                var e = t.proxy(function(e, i) {
                    return t.proxy(function(t) {
                        t.relatedTarget !== this && (this.suppress([i]), e.apply(this, [].slice.call(arguments, 1)), this.release([i]))
                    }, this)
                }, this);
                t.each({
                    next: this.next,
                    prev: this.prev,
                    to: this.to,
                    destroy: this.destroy,
                    refresh: this.refresh,
                    replace: this.replace,
                    add: this.add,
                    remove: this.remove
                }, t.proxy(function(t, i) {
                    this.$element.on(t + ".owl.carousel", e(i, t + ".owl.carousel"))
                }, this))
            }, o.prototype.watchVisibility = function() {
                function i(t) {
                    return t.offsetWidth > 0 && t.offsetHeight > 0
                }
                i(this.$element.get(0)) || (this.$element.addClass("owl-hidden"), e.clearInterval(this.e._checkVisibile), this.e._checkVisibile = e.setInterval(t.proxy(function() {
                    i(this.$element.get(0)) && (this.$element.removeClass("owl-hidden"), this.refresh(), e.clearInterval(this.e._checkVisibile))
                }, this), 500))
            }, o.prototype.preloadAutoWidthImages = function(e) {
                var i, s, o, n;
                i = 0, s = this, e.each(function(r, a) {
                    o = t(a), (n = new Image).onload = function() {
                        i++, o.attr("src", n.src), o.css("opacity", 1), i >= e.length && (s.state.imagesLoaded = !0, s.initialize())
                    }, n.src = o.attr("src") || o.attr("data-src") || o.attr("data-src-retina")
                })
            }, o.prototype.destroy = function() {
                this.$element.hasClass(this.settings.themeClass) && this.$element.removeClass(this.settings.themeClass), !1 !== this.settings.responsive && t(e).off("resize.owl.carousel"), this.transitionEndVendor && this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);
                for (var s in this._plugins) this._plugins[s].destroy();
                (this.settings.mouseDrag || this.settings.touchDrag) && (this.$stage.off("mousedown touchstart touchcancel"), t(i).off(".owl.dragEvents"), this.$stage.get(0).onselectstart = function() {}, this.$stage.off("dragstart", function() {
                    return !1
                })), this.$element.off(".owl"), this.$stage.children(".cloned").remove(), this.e = null, this.$element.removeData("owlCarousel"), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.unwrap()
            }, o.prototype.op = function(t, e, i) {
                var s = this.settings.rtl;
                switch (e) {
                    case "<":
                        return s ? t > i : i > t;
                    case ">":
                        return s ? i > t : t > i;
                    case ">=":
                        return s ? i >= t : t >= i;
                    case "<=":
                        return s ? t >= i : i >= t
                }
            }, o.prototype.on = function(t, e, i, s) {
                t.addEventListener ? t.addEventListener(e, i, s) : t.attachEvent && t.attachEvent("on" + e, i)
            }, o.prototype.off = function(t, e, i, s) {
                t.removeEventListener ? t.removeEventListener(e, i, s) : t.detachEvent && t.detachEvent("on" + e, i)
            }, o.prototype.trigger = function(e, i, s) {
                var o = {
                        item: {
                            count: this._items.length,
                            index: this.current()
                        }
                    },
                    n = t.camelCase(t.grep(["on", e, s], function(t) {
                        return t
                    }).join("-").toLowerCase()),
                    r = t.Event([e, "owl", s || "carousel"].join(".").toLowerCase(), t.extend({
                        relatedTarget: this
                    }, o, i));
                return this._supress[e] || (t.each(this._plugins, function(t, e) {
                    e.onTrigger && e.onTrigger(r)
                }), this.$element.trigger(r), this.settings && "function" == typeof this.settings[n] && this.settings[n].apply(this, r)), r
            }, o.prototype.suppress = function(e) {
                t.each(e, t.proxy(function(t, e) {
                    this._supress[e] = !0
                }, this))
            }, o.prototype.release = function(e) {
                t.each(e, t.proxy(function(t, e) {
                    delete this._supress[e]
                }, this))
            }, o.prototype.browserSupport = function() {
                if (this.support3d = r(["perspective", "webkitPerspective", "MozPerspective", "OPerspective", "MsPerspective"])[0], this.support3d) {
                    this.transformVendor = r(["transform", "WebkitTransform", "MozTransform", "OTransform", "msTransform"])[0];
                    this.transitionEndVendor = ["transitionend", "webkitTransitionEnd", "transitionend", "oTransitionEnd"][r(["transition", "WebkitTransition", "MozTransition", "OTransition"])[1]], this.vendorName = this.transformVendor.replace(/Transform/i, ""), this.vendorName = "" !== this.vendorName ? "-" + this.vendorName.toLowerCase() + "-" : ""
                }
                this.state.orientation = e.orientation
            }, t.fn.owlCarousel = function(e) {
                return this.each(function() {
                    t(this).data("owlCarousel") || t(this).data("owlCarousel", new o(this, e))
                })
            }, t.fn.owlCarousel.Constructor = o
        }(window.Zepto || window.jQuery, window, document), O = window.Zepto || window.jQuery, D = window, document, (j = function(t) {
            this._core = t, this._loaded = [], this._handlers = {
                "initialized.owl.carousel change.owl.carousel": O.proxy(function(t) {
                    if (t.namespace && this._core.settings && this._core.settings.lazyLoad && (t.property && "position" == t.property.name || "initialized" == t.type))
                        for (var e = this._core.settings, i = e.center && Math.ceil(e.items / 2) || e.items, s = e.center && -1 * i || 0, o = (t.property && t.property.value || this._core.current()) + s, n = this._core.clones().length, r = O.proxy(function(t, e) {
                                this.load(e)
                            }, this); s++ < i;) this.load(n / 2 + this._core.relative(o)), n && O.each(this._core.clones(this._core.relative(o++)), r)
                }, this)
            }, this._core.options = O.extend({}, j.Defaults, this._core.options), this._core.$element.on(this._handlers)
        }).Defaults = {
            lazyLoad: !1
        }, j.prototype.load = function(t) {
            var e = this._core.$stage.children().eq(t),
                i = e && e.find(".owl-lazy");
            !i || O.inArray(e.get(0), this._loaded) > -1 || (i.each(O.proxy(function(t, e) {
                var i, s = O(e),
                    o = D.devicePixelRatio > 1 && s.attr("data-src-retina") || s.attr("data-src");
                this._core.trigger("load", {
                    element: s,
                    url: o
                }, "lazy"), s.is("img") ? s.one("load.owl.lazy", O.proxy(function() {
                    s.css("opacity", 1), this._core.trigger("loaded", {
                        element: s,
                        url: o
                    }, "lazy")
                }, this)).attr("src", o) : ((i = new Image).onload = O.proxy(function() {
                    s.css({
                        "background-image": "url(" + o + ")",
                        opacity: "1"
                    }), this._core.trigger("loaded", {
                        element: s,
                        url: o
                    }, "lazy")
                }, this), i.src = o)
            }, this)), this._loaded.push(e.get(0)))
        }, j.prototype.destroy = function() {
            var t, e;
            for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
            for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
        }, O.fn.owlCarousel.Constructor.Plugins.Lazy = j, M = window.Zepto || window.jQuery, window, document, (L = function(t) {
            this._core = t, this._handlers = {
                "initialized.owl.carousel": M.proxy(function() {
                    this._core.settings.autoHeight && this.update()
                }, this),
                "changed.owl.carousel": M.proxy(function(t) {
                    this._core.settings.autoHeight && "position" == t.property.name && this.update()
                }, this),
                "loaded.owl.lazy": M.proxy(function(t) {
                    this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass) === this._core.$stage.children().eq(this._core.current()) && this.update()
                }, this)
            }, this._core.options = M.extend({}, L.Defaults, this._core.options), this._core.$element.on(this._handlers)
        }).Defaults = {
            autoHeight: !1,
            autoHeightClass: "owl-height"
        }, L.prototype.update = function() {
            this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass)
        }, L.prototype.destroy = function() {
            var t, e;
            for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
            for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
        }, M.fn.owlCarousel.Constructor.Plugins.AutoHeight = L, x = window.Zepto || window.jQuery, A = window, E = document, (P = function(t) {
            this._core = t, this._videos = {}, this._playing = null, this._fullscreen = !1, this._handlers = {
                "resize.owl.carousel": x.proxy(function(t) {
                    this._core.settings.video && !this.isInFullScreen() && t.preventDefault()
                }, this),
                "refresh.owl.carousel changed.owl.carousel": x.proxy(function() {
                    this._playing && this.stop()
                }, this),
                "prepared.owl.carousel": x.proxy(function(t) {
                    var e = x(t.content).find(".owl-video");
                    e.length && (e.css("display", "none"), this.fetch(e, x(t.content)))
                }, this)
            }, this._core.options = x.extend({}, P.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", x.proxy(function(t) {
                this.play(t)
            }, this))
        }).Defaults = {
            video: !1,
            videoHeight: !1,
            videoWidth: !1
        }, P.prototype.fetch = function(t, e) {
            var i = t.attr("data-vimeo-id") ? "vimeo" : "youtube",
                s = t.attr("data-vimeo-id") || t.attr("data-youtube-id"),
                o = t.attr("data-width") || this._core.settings.videoWidth,
                n = t.attr("data-height") || this._core.settings.videoHeight,
                r = t.attr("href");
            if (!r) throw new Error("Missing video URL.");
            if ((s = r.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1) i = "youtube";
            else {
                if (!(s[3].indexOf("vimeo") > -1)) throw new Error("Video URL not supported.");
                i = "vimeo"
            }
            s = s[6], this._videos[r] = {
                type: i,
                id: s,
                width: o,
                height: n
            }, e.attr("data-video", r), this.thumbnail(t, this._videos[r])
        }, P.prototype.thumbnail = function(t, e) {
            var i, s, o, n = e.width && e.height ? 'style="width:' + e.width + "px;height:" + e.height + 'px;"' : "",
                r = t.find("img"),
                a = "src",
                l = "",
                d = this._core.settings,
                c = function(e) {
                    s = '<div class="owl-video-play-icon"></div>', i = d.lazyLoad ? '<div class="owl-video-tn ' + l + '" ' + a + '="' + e + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + e + ')"></div>', t.after(i), t.after(s)
                };
            return t.wrap('<div class="owl-video-wrapper"' + n + "></div>"), this._core.settings.lazyLoad && (a = "data-src", l = "owl-lazy"), r.length ? (c(r.attr(a)), r.remove(), !1) : void("youtube" === e.type ? (o = "http://img.youtube.com/vi/" + e.id + "/hqdefault.jpg", c(o)) : "vimeo" === e.type && x.ajax({
                type: "GET",
                url: "http://vimeo.com/api/v2/video/" + e.id + ".json",
                jsonp: "callback",
                dataType: "jsonp",
                success: function(t) {
                    o = t[0].thumbnail_large, c(o)
                }
            }))
        }, P.prototype.stop = function() {
            this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null
        }, P.prototype.play = function(t) {
            this._core.trigger("play", null, "video"), this._playing && this.stop();
            var e, i, s = x(t.target || t.srcElement),
                o = s.closest("." + this._core.settings.itemClass),
                n = this._videos[o.attr("data-video")],
                r = n.width || "100%",
                a = n.height || this._core.$stage.height();
            "youtube" === n.type ? e = '<iframe width="' + r + '" height="' + a + '" src="http://www.youtube.com/embed/' + n.id + "?autoplay=1&v=" + n.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === n.type && (e = '<iframe src="http://player.vimeo.com/video/' + n.id + '?autoplay=1" width="' + r + '" height="' + a + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'), o.addClass("owl-video-playing"), this._playing = o, i = x('<div style="height:' + a + "px; width:" + r + 'px" class="owl-video-frame">' + e + "</div>"), s.after(i)
        }, P.prototype.isInFullScreen = function() {
            var t = E.fullscreenElement || E.mozFullScreenElement || E.webkitFullscreenElement;
            return t && x(t).parent().hasClass("owl-video-frame") && (this._core.speed(0), this._fullscreen = !0), !(t && this._fullscreen && this._playing || (this._fullscreen ? (this._fullscreen = !1, 1) : this._playing && this._core.state.orientation !== A.orientation && (this._core.state.orientation = A.orientation, 1)))
        }, P.prototype.destroy = function() {
            var t, e;
            this._core.$element.off("click.owl.video");
            for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
            for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
        }, x.fn.owlCarousel.Constructor.Plugins.Video = P, $ = window.Zepto || window.jQuery, window, document, (z = function(t) {
            this.core = t, this.core.options = $.extend({}, z.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
                "change.owl.carousel": $.proxy(function(t) {
                    "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
                }, this),
                "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": $.proxy(function(t) {
                    this.swapping = "translated" == t.type
                }, this),
                "translating.owl.carousel": $.proxy(function() {
                    this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
                }, this)
            }, this.core.$element.on(this.handlers)
        }).Defaults = {
            animateOut: !1,
            animateIn: !1
        }, z.prototype.swap = function() {
            if (1 === this.core.settings.items && this.core.support3d) {
                this.core.speed(0);
                var t, e = $.proxy(this.clear, this),
                    i = this.core.$stage.children().eq(this.previous),
                    s = this.core.$stage.children().eq(this.next),
                    o = this.core.settings.animateIn,
                    n = this.core.settings.animateOut;
                this.core.current() !== this.previous && (n && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), i.css({
                    left: t + "px"
                }).addClass("animated owl-animated-out").addClass(n).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", e)), o && s.addClass("animated owl-animated-in").addClass(o).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", e))
            }
        }, z.prototype.clear = function(t) {
            $(t.target).css({
                left: ""
            }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.transitionEnd()
        }, z.prototype.destroy = function() {
            var t, e;
            for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
            for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
        }, $.fn.owlCarousel.Constructor.Plugins.Animate = z, k = window.Zepto || window.jQuery, C = window, _ = document, (T = function(t) {
            this.core = t, this.core.options = k.extend({}, T.Defaults, this.core.options), this.handlers = {
                "translated.owl.carousel refreshed.owl.carousel": k.proxy(function() {
                    this.autoplay()
                }, this),
                "play.owl.autoplay": k.proxy(function(t, e, i) {
                    this.play(e, i)
                }, this),
                "stop.owl.autoplay": k.proxy(function() {
                    this.stop()
                }, this),
                "mouseover.owl.autoplay": k.proxy(function() {
                    this.core.settings.autoplayHoverPause && this.pause()
                }, this),
                "mouseleave.owl.autoplay": k.proxy(function() {
                    this.core.settings.autoplayHoverPause && this.autoplay()
                }, this)
            }, this.core.$element.on(this.handlers)
        }).Defaults = {
            autoplay: !1,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !1,
            autoplaySpeed: !1
        }, T.prototype.autoplay = function() {
            this.core.settings.autoplay && !this.core.state.videoPlay ? (C.clearInterval(this.interval), this.interval = C.setInterval(k.proxy(function() {
                this.play()
            }, this), this.core.settings.autoplayTimeout)) : C.clearInterval(this.interval)
        }, T.prototype.play = function() {
            return !0 === _.hidden || this.core.state.isTouch || this.core.state.isScrolling || this.core.state.isSwiping || this.core.state.inMotion ? void 0 : !1 === this.core.settings.autoplay ? void C.clearInterval(this.interval) : void this.core.next(this.core.settings.autoplaySpeed)
        }, T.prototype.stop = function() {
            C.clearInterval(this.interval)
        }, T.prototype.pause = function() {
            C.clearInterval(this.interval)
        }, T.prototype.destroy = function() {
            var t, e;
            C.clearInterval(this.interval);
            for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
            for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
        }, k.fn.owlCarousel.Constructor.Plugins.autoplay = T,
        function(t) {
            "use strict";
            var e = function(i) {
                this._core = i, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
                    next: this._core.next,
                    prev: this._core.prev,
                    to: this._core.to
                }, this._handlers = {
                    "prepared.owl.carousel": t.proxy(function(e) {
                        this._core.settings.dotsData && this._templates.push(t(e.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))
                    }, this),
                    "add.owl.carousel": t.proxy(function(e) {
                        this._core.settings.dotsData && this._templates.splice(e.position, 0, t(e.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))
                    }, this),
                    "remove.owl.carousel prepared.owl.carousel": t.proxy(function(t) {
                        this._core.settings.dotsData && this._templates.splice(t.position, 1)
                    }, this),
                    "change.owl.carousel": t.proxy(function(t) {
                        if ("position" == t.property.name && !this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
                            var e = this._core.current(),
                                i = this._core.maximum(),
                                s = this._core.minimum();
                            t.data = t.property.value > i ? e >= i ? s : i : t.property.value < s ? i : t.property.value
                        }
                    }, this),
                    "changed.owl.carousel": t.proxy(function(t) {
                        "position" == t.property.name && this.draw()
                    }, this),
                    "refreshed.owl.carousel": t.proxy(function() {
                        this._initialized || (this.initialize(), this._initialized = !0), this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation")
                    }, this)
                }, this._core.options = t.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers)
            };
            e.Defaults = {
                nav: !1,
                navRewind: !0,
                navText: ["prev", "next"],
                navSpeed: !1,
                navElement: "div",
                navContainer: !1,
                navContainerClass: "owl-nav",
                navClass: ["owl-prev", "owl-next"],
                slideBy: 1,
                dotClass: "owl-dot",
                dotsClass: "owl-dots",
                dots: !0,
                dotsEach: !1,
                dotData: !1,
                dotsSpeed: !1,
                dotsContainer: !1,
                controlsClass: "owl-controls"
            }, e.prototype.initialize = function() {
                var e, i, s = this._core.settings;
                s.dotsData || (this._templates = [t("<div>").addClass(s.dotClass).append(t("<span>")).prop("outerHTML")]), s.navContainer && s.dotsContainer || (this._controls.$container = t("<div>").addClass(s.controlsClass).appendTo(this.$element)), this._controls.$indicators = s.dotsContainer ? t(s.dotsContainer) : t("<div>").hide().addClass(s.dotsClass).appendTo(this._controls.$container), this._controls.$indicators.on("click", "div", t.proxy(function(e) {
                    var i = t(e.target).parent().is(this._controls.$indicators) ? t(e.target).index() : t(e.target).parent().index();
                    e.preventDefault(), this.to(i, s.dotsSpeed)
                }, this)), e = s.navContainer ? t(s.navContainer) : t("<div>").addClass(s.navContainerClass).prependTo(this._controls.$container), this._controls.$next = t("<" + s.navElement + ">"), this._controls.$previous = this._controls.$next.clone(), this._controls.$previous.addClass(s.navClass[0]).html(s.navText[0]).hide().prependTo(e).on("click", t.proxy(function() {
                    this.prev(s.navSpeed)
                }, this)), this._controls.$next.addClass(s.navClass[1]).html(s.navText[1]).hide().appendTo(e).on("click", t.proxy(function() {
                    this.next(s.navSpeed)
                }, this));
                for (i in this._overrides) this._core[i] = t.proxy(this[i], this)
            }, e.prototype.destroy = function() {
                var t, e, i, s;
                for (t in this._handlers) this.$element.off(t, this._handlers[t]);
                for (e in this._controls) this._controls[e].remove();
                for (s in this.overides) this._core[s] = this._overrides[s];
                for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
            }, e.prototype.update = function() {
                var t, e, i = this._core.settings,
                    s = this._core.clones().length / 2,
                    o = s + this._core.items().length,
                    n = i.center || i.autoWidth || i.dotData ? 1 : i.dotsEach || i.items;
                if ("page" !== i.slideBy && (i.slideBy = Math.min(i.slideBy, i.items)), i.dots || "page" == i.slideBy)
                    for (this._pages = [], t = s, e = 0, 0; o > t; t++)(e >= n || 0 === e) && (this._pages.push({
                        start: t - s,
                        end: t - s + n - 1
                    }), e = 0, 0), e += this._core.mergers(this._core.relative(t))
            }, e.prototype.draw = function() {
                var e, i, s = "",
                    o = this._core.settings,
                    n = (this._core.$stage.children(), this._core.relative(this._core.current()));
                if (!o.nav || o.loop || o.navRewind || (this._controls.$previous.toggleClass("disabled", 0 >= n), this._controls.$next.toggleClass("disabled", n >= this._core.maximum())), this._controls.$previous.toggle(o.nav), this._controls.$next.toggle(o.nav), o.dots) {
                    if (e = this._pages.length - this._controls.$indicators.children().length, o.dotData && 0 !== e) {
                        for (i = 0; i < this._controls.$indicators.children().length; i++) s += this._templates[this._core.relative(i)];
                        this._controls.$indicators.html(s)
                    } else e > 0 ? (s = new Array(e + 1).join(this._templates[0]), this._controls.$indicators.append(s)) : 0 > e && this._controls.$indicators.children().slice(e).remove();
                    this._controls.$indicators.find(".active").removeClass("active"), this._controls.$indicators.children().eq(t.inArray(this.current(), this._pages)).addClass("active")
                }
                this._controls.$indicators.toggle(o.dots)
            }, e.prototype.onTrigger = function(e) {
                var i = this._core.settings;
                e.page = {
                    index: t.inArray(this.current(), this._pages),
                    count: this._pages.length,
                    size: i && (i.center || i.autoWidth || i.dotData ? 1 : i.dotsEach || i.items)
                }
            }, e.prototype.current = function() {
                var e = this._core.relative(this._core.current());
                return t.grep(this._pages, function(t) {
                    return t.start <= e && t.end >= e
                }).pop()
            }, e.prototype.getPosition = function(e) {
                var i, s, o = this._core.settings;
                return "page" == o.slideBy ? (i = t.inArray(this.current(), this._pages), s = this._pages.length, e ? ++i : --i, i = this._pages[(i % s + s) % s].start) : (i = this._core.relative(this._core.current()), s = this._core.items().length, e ? i += o.slideBy : i -= o.slideBy), i
            }, e.prototype.next = function(e) {
                t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
            }, e.prototype.prev = function(e) {
                t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
            }, e.prototype.to = function(e, i, s) {
                var o;
                s ? t.proxy(this._overrides.to, this._core)(e, i) : (o = this._pages.length, t.proxy(this._overrides.to, this._core)(this._pages[(e % o + o) % o].start, i))
            }, t.fn.owlCarousel.Constructor.Plugins.Navigation = e
        }(window.Zepto || window.jQuery, window, document),
        function(t, e) {
            "use strict";
            var i = function(s) {
                this._core = s, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
                    "initialized.owl.carousel": t.proxy(function() {
                        "URLHash" == this._core.settings.startPosition && t(e).trigger("hashchange.owl.navigation")
                    }, this),
                    "prepared.owl.carousel": t.proxy(function(e) {
                        var i = t(e.content).find("[data-hash]").andSelf("[data-hash]").attr("data-hash");
                        this._hashes[i] = e.content
                    }, this)
                }, this._core.options = t.extend({}, i.Defaults, this._core.options), this.$element.on(this._handlers), t(e).on("hashchange.owl.navigation", t.proxy(function() {
                    var t = e.location.hash.substring(1),
                        i = this._core.$stage.children(),
                        s = this._hashes[t] && i.index(this._hashes[t]) || 0;
                    return !!t && void this._core.to(s, !1, !0)
                }, this))
            };
            i.Defaults = {
                URLhashListener: !1
            }, i.prototype.destroy = function() {
                var i, s;
                t(e).off("hashchange.owl.navigation");
                for (i in this._handlers) this._core.$element.off(i, this._handlers[i]);
                for (s in Object.getOwnPropertyNames(this)) "function" != typeof this[s] && (this[s] = null)
            }, t.fn.owlCarousel.Constructor.Plugins.Hash = i
        }(window.Zepto || window.jQuery, window, document)
}(theme.jQuery);

/* Slick */
(function(i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
})(function(i) {
    "use strict";
    var e = window.Slick || {};
    e = function() {
        function e(e, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(e),
                appendDots: i(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, t) {
                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(e).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, "undefined" != typeof document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
        }
        var t = 0;
        return e
    }(), e.prototype.activateADA = function() {
        var i = this;
        i.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, e.prototype.addSlide = e.prototype.slickAdd = function(e, t, o) {
        var s = this;
        if ("boolean" == typeof t) o = t, t = null;
        else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e)
        }), s.$slidesCache = s.$slides, s.reinit()
    }, e.prototype.animateHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({
                height: e
            }, i.options.speed)
        }
    }, e.prototype.animateSlide = function(e, t) {
        var o = {},
            s = this;
        s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
            left: e
        }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
            top: e
        }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({
            animStart: s.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function(i) {
                i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
            },
            complete: function() {
                t && t.call()
            }
        })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function() {
            s.disableTransition(), t.call()
        }, s.options.speed))
    }, e.prototype.getNavTarget = function() {
        var e = this,
            t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t
    }, e.prototype.asNavFor = function(e) {
        var t = this,
            o = t.getNavTarget();
        null !== o && "object" == typeof o && o.each(function() {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }, e.prototype.applyTransition = function(i) {
        var e = this,
            t = {};
        e.options.fade === !1 ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.autoPlay = function() {
        var i = this;
        i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }, e.prototype.autoPlayClear = function() {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }, e.prototype.autoPlayIterator = function() {
        var i = this,
            e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e))
    }, e.prototype.buildArrows = function() {
        var e = this;
        e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, e.prototype.buildDots = function() {
        var e, t, o = this;
        if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
            for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
        }
    }, e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass("draggable")
    }, e.prototype.buildRows = function() {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
            for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o), l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, e.prototype.checkResponsive = function(e, t) {
        var o, s, n, r = this,
            l = !1,
            d = r.$slider.width(),
            a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger("breakpoint", [r, l])
        }
    }, e.prototype.changeSlide = function(e, t) {
        var o, s, n, r = this,
            l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
            case "previous":
                s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                break;
            case "next":
                s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                break;
            case "index":
                var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                break;
            default:
                return
        }
    }, e.prototype.checkNavigable = function(i) {
        var e, t, o = this;
        if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];
        else
            for (var s in e) {
                if (i < e[s]) {
                    i = t;
                    break
                }
                t = e[s]
            }
        return i
    }, e.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.cleanUpRows = function() {
        var i, e = this;
        e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr("style"), e.$slider.empty().append(i))
    }, e.prototype.clickHandler = function(i) {
        var e = this;
        e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
    }, e.prototype.destroy = function(e) {
        var t = this;
        t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            i(this).attr("style", i(this).data("originalStyling"))
        }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
    }, e.prototype.disableTransition = function(i) {
        var e = this,
            t = {};
        t[e.transitionType] = "", e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.fadeSlide = function(i, e) {
        var t = this;
        t.cssTransitions === !1 ? (t.$slides.eq(i).css({
            zIndex: t.options.zIndex
        }), t.$slides.eq(i).animate({
            opacity: 1
        }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }), e && setTimeout(function() {
            t.disableTransition(i), e.call()
        }, t.options.speed))
    }, e.prototype.fadeSlideOut = function(i) {
        var e = this;
        e.cssTransitions === !1 ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, e.prototype.filterSlides = e.prototype.slickFilter = function(i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
    }, e.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick", "*", function(t) {
            var o = i(this);
            setTimeout(function() {
                e.options.pauseOnFocus && o.is(":focus") && (e.focussed = !0, e.autoPlay())
            }, 0)
        }).on("blur.slick", "*", function(t) {
            i(this);
            e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay())
        })
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        var i = this;
        return i.currentSlide
    }, e.prototype.getDotCount = function() {
        var i = this,
            e = 0,
            t = 0,
            o = 0;
        if (i.options.infinite === !0)
            if (i.slideCount <= i.options.slidesToShow) ++o;
            else
                for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else if (i.options.centerMode === !0) o = i.slideCount;
        else if (i.options.asNavFor)
            for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }, e.prototype.getLeft = function(i) {
        var e, t, o, s, n = this,
            r = 0;
        return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
    }, e.prototype.getOption = e.prototype.slickGetOption = function(i) {
        var e = this;
        return e.options[i]
    }, e.prototype.getNavigableIndexes = function() {
        var i, e = this,
            t = 0,
            o = 0,
            s = [];
        for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }, e.prototype.getSlick = function() {
        return this
    }, e.prototype.getSlideCount = function() {
        var e, t, o, s, n = this;
        return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find(".slick-slide").each(function(e, s) {
            var r, l, d;
            if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1
        }), e = Math.abs(i(t).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll
    }, e.prototype.goTo = e.prototype.slickGoTo = function(i, e) {
        var t = this;
        t.changeSlide({
            data: {
                message: "index",
                index: parseInt(i)
            }
        }, e)
    }, e.prototype.init = function(e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
    }, e.prototype.initADA = function() {
        var e = this,
            t = Math.ceil(e.slideCount / e.options.slidesToShow),
            o = e.getNavigableIndexes().filter(function(i) {
                return i >= 0 && i < e.slideCount
            });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
            var s = o.indexOf(t);
            if (i(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + e.instanceUid + t,
                    tabindex: -1
                }), s !== -1) {
                var n = "slick-slide-control" + e.instanceUid + s;
                i("#" + n).length && i(this).attr({
                    "aria-describedby": n
                })
            }
        }), e.$dots.attr("role", "tablist").find("li").each(function(s) {
            var n = o[s];
            i(this).attr({
                role: "presentation"
            }), i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.options.focusOnChange ? e.$slides.eq(s).attr({
            tabindex: "0"
        }) : e.$slides.eq(s).removeAttr("tabindex");
        e.activateADA()
    }, e.prototype.initArrowEvents = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }, e.prototype.initDotEvents = function() {
        var e = this;
        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), e.options.accessibility === !0 && e.$dots.on("keydown.slick", e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }, e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
    }, e.prototype.initUI = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }, e.prototype.keyHandler = function(i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
            data: {
                message: e.options.rtl === !0 ? "next" : "previous"
            }
        }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
            data: {
                message: e.options.rtl === !0 ? "previous" : "next"
            }
        }))
    }, e.prototype.lazyLoad = function() {
        function e(e) {
            i("img[data-lazy]", e).each(function() {
                var e = i(this),
                    t = i(this).attr("data-lazy"),
                    o = i(this).attr("data-srcset"),
                    s = i(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
                    n = document.createElement("img");
                n.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), r.$slider.trigger("lazyLoaded", [r, e, t])
                    })
                }, n.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, t])
                }, n.src = t
            })
        }
        var t, o, s, n, r = this;
        if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find(".slick-slide").slice(s, n), "anticipated" === r.options.lazyLoad)
            for (var l = s - 1, d = n, a = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
        e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find(".slick-slide"), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find(".slick-cloned").slice(r.options.slidesToShow * -1), e(o))
    }, e.prototype.loadSlider = function() {
        var i = this;
        i.setPosition(), i.$slideTrack.css({
            opacity: 1
        }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }, e.prototype.next = e.prototype.slickNext = function() {
        var i = this;
        i.changeSlide({
            data: {
                message: "next"
            }
        })
    }, e.prototype.orientationChange = function() {
        var i = this;
        i.checkResponsive(), i.setPosition()
    }, e.prototype.pause = e.prototype.slickPause = function() {
        var i = this;
        i.autoPlayClear(), i.paused = !0
    }, e.prototype.play = e.prototype.slickPlay = function() {
        var i = this;
        i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
    }, e.prototype.postSlide = function(e) {
        var t = this;
        if (!t.unslicked && (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
            var o = i(t.$slides.get(t.currentSlide));
            o.attr("tabindex", 0).focus()
        }
    }, e.prototype.prev = e.prototype.slickPrev = function() {
        var i = this;
        i.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, e.prototype.preventDefault = function(i) {
        i.preventDefault()
    }, e.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var t, o, s, n, r, l = this,
            d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), r = document.createElement("img"), r.onload = function() {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
        }, r.onerror = function() {
            e < 3 ? setTimeout(function() {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
        }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }, e.prototype.refresh = function(e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
            currentSlide: t
        }), s.init(), e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }, e.prototype.registerBreakpoints = function() {
        var e, t, o, s = this,
            n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n)
                if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                    s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
                } s.breakpoints.sort(function(i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }, e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, e.prototype.resize = function() {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, e.prototype.removeSlide = e.prototype.slickRemove = function(i, e, t) {
        var o = this;
        return "boolean" == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit())
    }, e.prototype.setCSS = function(i) {
        var e, t, o = this,
            s = {};
        o.options.rtl === !0 && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
    }, e.prototype.setDimensions = function() {
        var i = this;
        i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
            padding: "0px " + i.options.centerPadding
        }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
            padding: i.options.centerPadding + " 0px"
        })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        i.options.variableWidth === !1 && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }, e.prototype.setFade = function() {
        var e, t = this;
        t.$slides.each(function(o, s) {
            e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            })
        }), t.$slides.eq(t.currentSlide).css({
            zIndex: t.options.zIndex - 1,
            opacity: 1
        })
    }, e.prototype.setHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function() {
        var e, t, o, s, n, r = this,
            l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : "undefined" != typeof arguments[1] && (n = "single")), "single" === n) r.options[o] = s;
        else if ("multiple" === n) i.each(o, function(i, e) {
            r.options[i] = e
        });
        else if ("responsive" === n)
            for (t in s)
                if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                    r.options.responsive.push(s[t])
                } l && (r.unload(), r.reinit())
    }, e.prototype.setPosition = function() {
        var i = this;
        i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
    }, e.prototype.setProps = function() {
        var i = this,
            e = document.body.style;
        i.positionProp = i.options.vertical === !0 ? "top" : "left",
            "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1
    }, e.prototype.setSlideClasses = function(i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), n.options.centerMode === !0) {
            var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
        } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }, e.prototype.setupInfinite = function() {
        var e, t, o, s = this;
        if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
            for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                i(this).attr("id", "")
            })
        }
    }, e.prototype.interrupt = function(i) {
        var e = this;
        i || e.autoPlay(), e.interrupted = i
    }, e.prototype.selectHandler = function(e) {
        var t = this,
            o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
            s = parseInt(o.attr("data-slick-index"));
        return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s)
    }, e.prototype.slideHandler = function(i, e, t) {
        var o, s, n, r, l, d = null,
            a = this;
        if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void(a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function() {
            a.postSlide(o)
        }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void(a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function() {
            a.postSlide(o)
        }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick("getSlick"), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function() {
            a.postSlide(s)
        })) : a.postSlide(s), void a.animateHeight()) : void(t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function() {
            a.postSlide(s)
        }) : a.postSlide(s)))
    }, e.prototype.startLoad = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
    }, e.prototype.swipeDirection = function() {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? "left" : "right" : o <= 360 && o >= 315 ? s.options.rtl === !1 ? "left" : "right" : o >= 135 && o <= 225 ? s.options.rtl === !1 ? "right" : "left" : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }, e.prototype.swipeEnd = function(i) {
        var e, t, o = this;
        if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
        if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
        if (o.touchObject.edgeHit === !0 && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
                case "left":
                case "down":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
        } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
    }, e.prototype.swipeHandler = function(i) {
        var e = this;
        if (!(e.options.swipe === !1 || "ontouchend" in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf("mouse") !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
            case "start":
                e.swipeStart(i);
                break;
            case "move":
                e.swipeMove(i);
                break;
            case "end":
                e.swipeEnd(i)
        }
    }, e.prototype.swipeMove = function(i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
    }, e.prototype.swipeStart = function(i) {
        var e, t = this;
        return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void(t.dragging = !0))
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var i = this;
        null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
    }, e.prototype.unload = function() {
        var e = this;
        i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, e.prototype.unslick = function(i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy()
    }, e.prototype.updateArrows = function() {
        var i, e = this;
        i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, e.prototype.updateDots = function() {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }, e.prototype.visibility = function() {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }, i.fn.slick = function() {
        var i, t, o = this,
            s = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            r = o.length;
        for (i = 0; i < r; i++)
            if ("object" == typeof s || "undefined" == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), "undefined" != typeof t) return t;
        return o
    }
});

/* Custom Code - Preversion customized.js */
! function(e) {
    if ((e = jQuery = e)(document).ready(function() {
            e("#closeAnn").click(function() {
                e(".announcement").css("display", "none")
            }), e(".filter-group h4").addClass("toggleFilter"), e(".toggleFilter").siblings().addClass("visible"), e(".toggleFilter").click(function() {
                e(this).toggleClass("twistchevron"), e(this).siblings().toggleClass("hidden visible"), e(".pt-display-dropdown .scroll-content").removeClass("hidden visible")
            }), e(".toggleFilter").siblings().hasClass("hidden") && e(this).addClass("twistchevron"), e(".pt-display-dropdown .scroll-content").removeClass("hidden visible")
        }), e(window).width() > 767) {
        window.onscroll = function() {
            window.pageYOffset >= i ? (n.classList.add("stickyheader"), t.classList.add("offsetbodycont"), e(".anouncement-bar").addClass("stickyann")) : (n.classList.remove("stickyheader"), t.classList.remove("offsetbodycont"), e(".anouncement-bar").removeClass("stickyann"))
        };
        var n = document.getElementById("main-nav"),
            t = document.getElementById("content"),
            i = n.offsetTop
    }

    function a() {
        if (e(window).width() < 767) {
            e("#content").removeClass("offsetbodycont");
            var n = e("#shopify-section-1478795901388").height();
            e(".section-id-1529067468471").css("margin-top", n + 30), e(".toggleFilter").siblings().removeClass("visible"), e(".toggleFilter").siblings().addClass("hidden"), e(".toggleFilter").addClass("twistchevron"), 0 == e(".main-content .user-content").length && e(".side-menu .user-content").clone().insertAfter(".collection-listing"), e("#mobile-header .utils .account-links").insertAfter(".vertical-mega-menu"), e(".main-content .pagination_wrapper").insertAfter(".collection-listing")
        } else e("#main-nav .account-links").remove(), e("#shopify-section-1478606449157").css("margin-top", 0), e(".main-content .user-content").remove(), e("body").removeClass("reveal-mobile-nav")
    }

    function s() {
        var n = e(".rimage__image").height();
        e(".sofacollection .product-block .product-info").css("height", n), e(".sofacollection .product-block").css("height", n)
    }

    function o() {
        e("#selectedcolor").text(e(".currentSwatch").attr("data-name"))
    }

    function l() {
        e(".fullwidth-header-abs img").height(), e(".firstoftype")
    }

  
    function r() {
        /*e(".collection-listing").each(function() {
            var n = 0;
            e(".product-info .title", this).each(function() {
                e(this).height() > n && (n = e(this).height())
            }), e(".product-info .title", this).css("height", n)
        })
        */
    }
	
    function c() {
        e(".collection-listing").each(function() {
            var n = 0;
            e(".product-block", this).each(function() {
                e(this).height() > n && (n = e(this).height())
            }), e(".product-block", this).css("min-height", n)
        })
    }
    e(window).on("resize", a), e(document).ready(a), e(window).on("resize", s), e(document).ready(s), e(".reducedfrom") && e(this).next(".price .theme-money").addClass("redprice"), e(".filter-menu").addClass("pt-expand"), e(".featured_content .custom-fields-wrapper .custom-field__featuredheadermanual").length && e(".page-header h1.majortitle").css("opacity", "0"), e("#accordion h3").click(function() {
        e(this).toggleClass("twistx"), e(this).next("div").toggleClass("uncollapsed")
    }), e(".buddha-menu-item a[aria-label='Sale']").addClass("redden"), e(window).width() > 767 ? setInterval(function() {
        e(".mm-submenu a[aria-label='SONSTIGE']").addClass("blockify"), e(".mm-submenu a[aria-label='TEPPICHE']").addClass("blockify"),e(".mm-submenu a[aria-label='FLUR & DIELEN']").addClass("blockify"), e(".mm-submenu a[aria-label='ARBEITSZIMMER']").addClass("blockify"), e(".mm-submenu a[aria-label='BADEZIMMER']").addClass("blockify"), e(".mm-submenu a [aria-label='Mossoro Lounge']").addClass("blockify"), e(".mm-submenu a[aria-label='Mossoro Lounge'] img").addClass("specialbannerimage-outdoor"), e(".mm-submenu a[aria-label='Esstisch'] img").addClass("specialbannerimage"), e(".specialbannerimage").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage-outdoor").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/navi_bilder_02-021-11.jpg?v=1631717652"), e(".specialbannerimage-outdoor").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/ecklounge_bali_menu_darkened.jpg?v=1618124744"), e(".mm-submenu a[aria-label='Outdoorteppich'] img").addClass("specialbannerimage-outdoorteppich"), e(".specialbannerimage-outdoorteppich").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage-outdoorteppich").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/navi_bilder_02-021-11.jpg?v=1631717652"), e(".specialbannerimage--ethnicraft").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/esstisch-bok-oak-menu-item.jpg?v=1613670525"), e(".mm-submenu a[aria-label='Schaffelle'] img").addClass("specialbannerimage--schaffelle"), e(".specialbannerimage--schaffelle").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage--schaffelle").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/navi_bilder_02-021-09.jpg?v=1631717675"), e(".mm-submenu a[aria-label='Rattanleuchte'] img").addClass("specialbannerimage--rattanleuchte"), e(".mm-submenu a[aria-label='Ethnicraft'] img").addClass("specialbannerimage--ethnicraft"), e(".specialbannerimage--rattanleuchte").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage--ethnicraft").parents(".mm-submenu li").addClass("specialli"), e(".specialbannerimage--rattanleuchte").attr("src", "https://cdn.shopify.com/s/files/1/0018/5647/1095/files/navi_bilder-08.jpg?v=1622639576"), e(".mm-submenu a[aria-label='Rattanleuchte'] .cta--header").length < 1 && e(".specialbannerimage--rattanleuchte").parent("a").append("<span class='cta--header'>UMAGE Pendelleuchte | Asteria</span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Ethnicraft'] .cta--header").length < 1 && e(".specialbannerimage--ethnicraft").parent("a").append("<span class='cta--header'>Lässig speisen! Esstisch Bok aus Eiche.</span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Mossoro Lounge'] .cta--header").length < 1 && e(".specialbannerimage-outdoor").parent("a").append("<span class='cta--header'>Bequeme Ecklounge schon für 999,00 !</span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Outdoorteppich'] .cta--header").length < 1 && e(".specialbannerimage-outdoorteppich").parent("a").append("<span class='cta--header'>Für die kalten Nächte: Kissen und Lammfelle</span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Schaffelle'] .cta--header").length < 1 && e(".specialbannerimage--schaffelle").parent("a").append("<span class='cta--header'>Kaminholz-Körbe ab 60,00€! </span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Rattanleuchte'] .cta--header").length < 1 && e(".specialbannerimage--ethnicraft").parent("a").append("<span class='cta--header'></span><button class='inv_shopnow'>Jetzt shoppen</button>"), e(".mm-submenu a[aria-label='Rattanleuchte'] .cta--header").length < 1 && e(".specialbannerimage--rattanleuchte").parent("a").append("<span class='cta--header'></span><button class='inv_shopnow'>Jetzt shoppen</button>")
    }, 100) : e(".specialbannerimage").hide(), e("#shopify-section-product-template select").on("change", o), e(".sofatemplate select").on("change", o), e(document).ready(o), e("label[for='option-color']").append("<br><span id='selectedcolor'></span>"), e("label[for='option-farbe']").append("<br><span id='selectedcolor'></span>"), e("label[for='option-bezug']").append("<br><span id='selectedcolor'></span>"), setInterval(function() {
        e(".buddha-menu-item a[aria-label='Styles'], .buddha-menu-item a[aria-label='Teppiche']").siblings(".mm-submenu").addClass("stylemenu-5"), 0 == e(".buddha-menu-item .submenu-header").length && (e(".buddha-menu-item").each(function() {
            e(this).children(".mm-submenu").first().prepend("<div class='submenu-header'><span class='submenu-header-title'></span></div>")
        }), e(".submenu-header-title").each(function() {
            var n = e(this).parents().parents().siblings("a").text();
            e(this).text(n)
        }))
    }, 100), e(".template-index .collection-slider-row").addClass("container"), e('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(n) {
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            var t = e(this.hash);
            (t = t.length ? t : e("[name=" + this.hash.slice(1) + "]")).length && (n.preventDefault(), e("html, body").animate({
                scrollTop: t.offset().top
            }, 500, function() {
                var n = e(t);
                if (n.focus(), n.is(":focus")) return !1;
                n.attr("tabindex", "-1"), n.focus()
            }))
        }
    }), e(".infotrigger").mouseenter(function() {
        e(this).next(".infobox").removeClass("hd-elem")
    }), e(".infotrigger").mouseleave(function() {
        e(this).next(".infobox").addClass("hd-elem")
    }), e(".thumbnails a").click(function() {
        e(".fancybox-container").hide()
    }), e(".fancybox-toolbar .fancybox-button svg").attr("viewbox", "0 0 23 23"), e(".btn-val").on("click", function() {
        var n = e(this),
            t = n.siblings().find("#quantity").val();
        if ("+" == n.text()) var i = parseFloat(t) + 1;
        else i = t > 0 ? parseFloat(t) - 1 : 0;
        n.siblings().find("#quantity").val(i)
    }), setInterval(function() {
        1 == e(".was-price").parents(".current-price").length && e(".current-price > .was-price").remove(), 1 == e(".current-price").parents(".was-price").length && e(".was-price > .parents-price").remove()
    }, 1), e(window).on("resize", l), e(document).ready(l), setInterval(function() {
        e(".anc .t1").addClass("invisible"), e(".anc .t2").removeClass("invisible")
    }, 3e3), setTimeout(function() {
        setInterval(function() {
            e(".anc .t2").addClass("invisible"), e(".anc .t1").removeClass("invisible")
        }, 6e3)
    }, 3e3), e(document).ready(r), e(window).on("resize", r), e(".sofatemplate .gallery"), e(".sofatemplate .majorinfowrapper").height(), e(".sofatemplate .sofakonfig").height(), e(".sofatemplate .tp-wrapper").height(), e(".sofatemplate .selector-Bezug").height(), 0 == e(".seo-content").children().length && e(".seo-content").hide(), e(document).ready(c), e(window).on("resize", c), e(document).ready(function() {
        e(".fullwidth-header-abs").length && e(".mt--container").hide()
    })

}(theme.jQuery);

    
  $(document).ready(function () {

 $('.horizontal-mega-menu').on('mouseenter', '.buddha-menu-item', function() {
		$(".regularmenublackbackdrop").addClass("backedin")
    });
 	$('.horizontal-mega-menu').on('mouseleave', '.buddha-menu-item', function() {
		$(".regularmenublackbackdrop").removeClass("backedin")
    });
    
    $(".pagination-row .next a, .pagination-row .prev a").text("");
$(".sel-cust label").click(function(){
  $(this).toggleClass("active")
	$(this).next().toggleClass("activeToggle")
})
    
  });


  
    



   


